import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  QueryList,
  ViewChildren,
  OnDestroy,
  AfterViewInit,
  Renderer2,
  ChangeDetectorRef,
  HostListener,
  SecurityContext
} from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";
import { ChatGPTService } from "src/app/services/chat-gpt.service";
import { IaConfiguracaoAcaoFonteEnum } from 'src/app/enums/integration/iaConfiguracaoAcaoFonte.enum';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { TokenService } from "src/app/core/token/token.service";
import { ChatService } from "src/app/services/chat.service";
import { WebsocketService } from "src/app/core/websocket/websocket.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ChatFinalizarComponent } from "../chat-finalizar/chat-finalizar.component";
import { DetalhesContatoChatComponent } from "../detalhes-contato-chat/detalhes-contato-chat.component";
import { TranslateService } from "@ngx-translate/core";
import { ModalTransferenciaTicketComponent } from "../modal-transferencia-ticket/modal-transferencia-ticket.component";
import { ModalChatConciliarComponent } from "../modal-chat-conciliar/modal-chat-conciliar.component";
import { ModalChatContatoComponent } from "../modal-chat-contato/modal-chat-contato.component";
import { ConversaZapComponent } from "../conversa-zap/conversa-zap.component";
import Swal from "sweetalert2";
import { SimpleCrypt } from "ngx-simple-crypt";
import { ModalAberturaTicketComponent } from "../modal-abertura-ticket/modal-abertura-ticket.component";
import { BehaviorSubject, debounceTime, forkJoin, Subject, Subscription } from "rxjs";
import { ChatViewerAudioComponent } from "../chat-viewer-audio/chat-viewer-audio.component";
import { Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { EllipsisPipe } from "src/app/shared/validators/pipes/elilipsis.pipe";
import { WhatsappService } from "src/app/services/whatsapp.service";
import { ModalContatosComponent } from "../modal-contatos/modal-contatos.component";
import { TicketService } from "src/app/services/ticket.service";
import { IntegrationService } from "src/app/services/integration.service";
import { ModalHistoricoListaChatsComponent } from "../modal-historico-lista-chats/modal-historico-lista-chats.component";
import { ModalMsgStartChatWhatsappComponent } from "../modal-msg-start-chat-whatsapp/modal-msg-start-chat-whatsapp.component";
import { ModalIniciarAtendimentoChatComponent } from "../modal-iniciar-atendimento-chat/modal-iniciar-atendimento-chat.component";
import { VisualizadorArquivosComponent } from "../visualizador-arquivos/visualizador-arquivos.component";
import { ChatHistoricoUnificadoComponent } from "../chat-historico-unificado/chat-historico-unificado.component";
import { ChatHistoricoUsoBaseIaComponent } from "../chat-historico-uso-base-ia/chat-historico-uso-base-ia.component";
import { ModalClienteContatoComponent } from "../modal-cliente-contato/modal-cliente-contato.component";
import { ModalOpenAITemplateComponent } from "../modal-openai-template/modal-openai-template.component";
import { ConfiguracaoTemplateService } from "src/app/services/configuracao-template.service";
import { TemplatesService } from "src/app/services/templates.service";
import { FuncoesGlobaisService } from "src/app/services/funcoes-globais.service";
import { DadosEmpresaService } from "src/app/services/dados-empresa.service";
import { UsuariosService } from "src/app/services/usuarios.service";
import { AlertasPushService } from "src/app/services/alertas-push.service";
import { MaskApplierService } from "ngx-mask";
import { CountriesMask } from "src/app/variables/countries-phones";
import { ModalTicketRetidoBloquearEmailComponent } from "../modal-ticket-retido-bloquear-email/modal-ticket-retido-bloquear-email.component";
import { ModalEnviarEmailComponent } from "../modal-enviar-email/modal-enviar-email.component";
import { ThemeService } from "src/app/shared/themes/theme.service";
import { validateResourceUrl } from "src/app/shared/utils/safe-resource-url.util";
import {
  STATUS_CHAT,
  STATUS_SITUACAO_CHAT,
  TIPO_ENCERRAMENTO_CHAT,
} from "src/app/variables/chat-status";
import { IaConfiguracaoFeatureEnum } from 'src/app/enums/integration/iaConfiguracaoFeature.enum';
declare let moment: any;

const EMAIL_ATTACHMENT_ALLOWED_DOMAINS = ['amazonaws.com'];

@Component({
  selector: "app-chat-viewer",
  templateUrl: "./chat-viewer.component.html",
  styleUrls: ["./chat-viewer.component.scss"],
})
export class ChatViewerComponent implements OnInit, AfterViewInit, OnDestroy {
  createAnswerToChat: UntypedFormGroup = new UntypedFormGroup({
    chatGPT: new UntypedFormControl("", Validators.required),
    description: new UntypedFormControl("", Validators.required),
  });
  @Input() whatsAppContato;
  @Input() contato;
  @Input() historico_chat;
  @Input() provider_id;
  @Input() apenas_historico;
  @Input() chatGPTSuggestion;
  @Input() allowChatGPT;
  @Input() closeChatGPTModal = true;
  isAIExpanded: boolean = false;
  @Input() recebeStatusMessage;
  @Input() chatIdRecebido;
  chatGPTSuggestionCopy: any;
  contatoForm: UntypedFormGroup;
  tokenData: any;
  searchText: string;
  tempo_expirar: boolean = false;
  searchText$ = new Subject<string>();
  listaChats: any = [];
  chatSelecionado: any;
  mensagensChat: any;
  // MIL-30097: transcrições que chegaram pelo socket antes do histórico carregar
  private transcricoesAntesDoHistorico: any[] = [];
  mensagem: any;
  respostaSelecionada: any;
  activeIndex: any;
  reenviarMensagem: any;
  socketsAbertos: any = [];
  contadores: any;
  lockedScroll: boolean = false;
  chatSelecionadoSocket: any;
  showEmoji: boolean = false;
  _this = this;
  statusSelecionado: any = 2;
  gruposSelecionado: boolean = false;
  locked: boolean = true;
  chatAtivoId: string = "";
  isMostrarHistoricoUsoBaseIa: boolean = false;
  loading: boolean;
  seeMoreLength = 300;
  conectado: any;
  reconectando: any;
  tentativas = 0;
  tooMany: any;
  permissao = {
    VisualizarTickets: this.tokenService.checkPermissions("@VisualizarTickets"),
    VisualizarGruposWhatsappChat: this.tokenService.checkPermissions("@VisualizarGruposWhatsappChat"),
    VisualizarAgFilaChat: this.tokenService.checkPermissions("@VisualizarAgFilaChat")
  };
  focus = true;
  selector: string;
  dataAtual = new Date();
  newSubs: Subscription;
  arrayFilasExistentes: Array<number> = [];
  traducaoEmoji = {
    search: this.translate.instant("BUSCAR"),
    emojilist: this.translate.instant("LISTA_EMOJIS"),
    notfound: this.translate.instant("NENHUM_EMOJI_ENCONTRADO"),
    clear: this.translate.instant("LIMPAR"),
    categories: {
      search: this.translate.instant("RESULTADOS_PESQUISA"),
      recent: this.translate.instant("USADOS_RECENTEMENTE"),
      people: this.translate.instant("EXPRESSOES_PESSOAS"),
      nature: this.translate.instant("ANIMAIS_NATUREZA"),
      foods: this.translate.instant("COMIDAS_BEBIDAS"),
      activity: this.translate.instant("ATIVIDADE"),
      places: this.translate.instant("VIAGEM_LUGARES"),
      objects: this.translate.instant("OBJETOS"),
      symbols: this.translate.instant("SIMBOLOS"),
      flags: this.translate.instant("BANDEIRAS"),
      custom: this.translate.instant("CUSTOMIZADOS"),
    },
  };
  lastMsgSendStatus: boolean;
  tooManyMsg;
  seeMoreTranscriptionItems: Record<string, {
    transcriptionId: string;
    collapsedText: string;
    expandedText: string;
  }> = {};
  uploadFileType = environment.getUploadConfig().docImg();
  uploadFileSize = environment.getUploadConfig().sizeMaxBytes;
  socketRealTime: any;
  solicitantes_habilitados: any = {
    solicitante_cliente: true,
    solicitante_contato: true,
    solicitante_operador: true
  };

  paginaChats: number = 1;
  offSetChats: number = 15;
  filtroChat: any;
  carregandoChats: boolean = false;
  totalRegistrosChats!: number;

  statusChange$ = new BehaviorSubject<number>(2);
  loadingChats: boolean = true;
  loadingScroll: boolean = true;

  @ViewChild("scrollMe") private myScrollContainer: ElementRef;
  @ViewChildren("messages") messages: QueryList<any>;
  @ViewChild("templatePreviewPopover") templatePreviewPopover: ElementRef;
  @ViewChild("fileInputAnexoChat") fileInput: ElementRef;
  @ViewChild("chatList") chatList: ElementRef;
  @ViewChild("chatBox") chatBox: ElementRef;
  isModalOpen: boolean = false;
  integracaoCompleta: boolean = false;
  hasIntegracao: boolean = false;
  private erro131047JaExibido: Map<string, boolean> = new Map();
  private contatoSelecionado: any;
  chatlistScrolled$ = new BehaviorSubject(null);
  chatPaginationProperties;
  provider_id_conversa: number = null;
  msgSelecionadas: Array<any> = [];
  msgsTransferidas: Array<any> = [];
  trocandoChat: boolean = false;
  addOnTab: number = 1;
  templatesChat: Array<any> = [];
  pesquisaTemplates: string = '';
  templatesSomenteMeta: boolean = false;
  integracaoGrupos: boolean = false;
  nomeEmpresa: string = '';
  operador: string = '';
  private unlisteners: Array<() => void> = [];
  integrationGoogleSchedule: any = { hasIntegrationGoogleSchedule: false };
  integrationOutlookSchedule: any = { hasIntegrationOutlookSchedule: false };
  enviandoLinkReuniao: boolean = false;
  intervalNumerosDesconectados: any;
  numerosDesconectados: object[] = [];
  templatePreview = {
    visible: false,
    top: 0,
    left: 0,
    arrowTop: 18,
    arrowSide: 'right',
    template: null
  };
  isChatGrupo: boolean = false;
  private templatePreviewHideTimeout: any;
  private envioLocalPendente: Array<{
    clientTempId: string;
    chatId: string;
    message: string;
    createdAt: number;
    ignoreAtualizacaoChat: boolean;
    ignoreBuscaConversa: boolean;
    status: 'sending' | 'error' | 'sent';
    errorMessage?: string;
    payload?: any;
  }> = [];
  private readonly janelaIgnorarEnvioLocalMs = 10000;
  private readonly chaveEnviosLocaisPendentesStorage = '@milvus:chatEnviosLocaisPendentes';
  private readonly janelaProtecaoEnvioDuplicadoMs = 800;
  private protecaoEnvioDuplicado = new Map<string, number>();

  constructor(
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    public translate: TranslateService,
    private tokenService: TokenService,
    private chatService: ChatService,
    private websocketService: WebsocketService,
    private modalService: NgbModal,
    private elemRef: ElementRef,
    private router: Router,
    private sanitizer: DomSanitizer,
    private ellipsisPipe: EllipsisPipe,
    private whatsappService: WhatsappService,
    private ticketService: TicketService,
    private chatGPTService: ChatGPTService,
    private integrationService: IntegrationService,
    private renderer: Renderer2,
    private cd: ChangeDetectorRef,
    private configTemplatesService: ConfiguracaoTemplateService,
    private templatesService: TemplatesService,
    private funcoesGlobaisService: FuncoesGlobaisService,
    private dadosEmpresaService: DadosEmpresaService,
    private usuariosService: UsuariosService,
    private alertasPushService: AlertasPushService,
    private mask: MaskApplierService,
    public themeService: ThemeService
  ) {
    this.selector = this.elemRef.nativeElement.tagName.toLowerCase();
    this.searchText$
      .pipe(
        debounceTime(1000)
      )
      .subscribe(value => {
        this.paginaChats = 1;
        this.loadChats();
      });

    this.newSubs = this.statusChange$
      .subscribe({
        next: value => {
          this.gruposSelecionado = false;
          if (this.statusSelecionado === value) {
            return;
          }
          if (value) {
            this.loadingChats = true;
            this.statusSelecionado = value;
            this.listaChats = [];
            this.paginaChats = 1;
            this.offSetChats = this.buscaGuardaQntChatSalvo(true);
            this.searchText = '';
            this.totalRegistrosChats = undefined;

            if (this.tokenData && this.tokenData.id) {
              if (value === 4 || value === 5) {
                this.loadChats(value === 4 ? 'somente_ag_fila' : 'somente_ag_minha_resposta');
              } else {
                this.loadChats();
              }
              this.loadContadores();
            }
          }
        }
      })

    this.chatlistScrolled$
      .pipe(
        debounceTime(500)
      )
      .subscribe(event => {
        if (this.chatList && event) {
          const scrollPosition = this.chatList.nativeElement.scrollTop;
          const scrollHeight = this.chatList.nativeElement.scrollHeight;
          const offsetHeight = this.chatList.nativeElement.offsetHeight;

          if (!this.totalRegistrosChats) {
            return
          }

          // if (this.paginaChats === (this.chatPaginationProperties.last_page + 1)) {
          //   return
          // }
          if (this.offSetChats >= this.totalRegistrosChats) {
            return;
          }

          if (scrollPosition + offsetHeight >= scrollHeight - 100) {
            this.loadingScroll = true;
            if (!this.carregandoChats) {
              // this.paginaChats = this.paginaChats === 1 ? 2 : this.paginaChats;
              this.offSetChats = this.offSetChats + 15;
              this.buscaGuardaQntChatSalvo(false);
              this.loadChats();
            }
          } else if (scrollPosition === 0) {
            console.log('Chegou ao topo do chat');
          }
        }
      });
  }

  @HostListener('scroll', ['$event'])
  onScrollChatList(event: any): void {
    if (event) {
      this.chatlistScrolled$.next(event);
    }
  }

  onSearchTermChange(value: string) {
    this.loadingChats = true;
    this.searchText$.next(value);
  }

  handleClick(event: MouseEvent) {
    const emojiSelector = document.querySelector(".emoji-selector");
    if (emojiSelector && !emojiSelector.contains(event.target as Node)) {
      this.showEmoji = false;
    }
  }

  showTemplatePreview(event: MouseEvent, template: any): void {
    clearTimeout(this.templatePreviewHideTimeout);

    const modalElement = this.elemRef.nativeElement.querySelector('.chat-viewer-modal-content') as HTMLElement;
    const triggerElement = event.currentTarget as HTMLElement;

    if (!modalElement || !triggerElement) {
      return;
    }

    const modalRect = modalElement.getBoundingClientRect();
    const triggerRect = triggerElement.getBoundingClientRect();
    const scaleX = modalRect.width && modalElement.offsetWidth ? modalRect.width / modalElement.offsetWidth : 1;
    const scaleY = modalRect.height && modalElement.offsetHeight ? modalRect.height / modalElement.offsetHeight : 1;

    const triggerLeft = (triggerRect.left - modalRect.left) / scaleX;
    const triggerRight = (triggerRect.right - modalRect.left) / scaleX;
    const triggerTop = (triggerRect.top - modalRect.top) / scaleY;
    const triggerHeight = triggerRect.height / scaleY;

    this.templatePreview = {
      visible: true,
      top: 0,
      left: 0,
      arrowTop: 18,
      arrowSide: 'right',
      template
    };

    this.cd.detectChanges();

    setTimeout(() => {
      this.positionTemplatePreview(
        modalElement,
        triggerLeft,
        triggerRight,
        triggerTop,
        triggerHeight
      );
    }, 0);
  }

  private getTimestamp(msg: any): number {
    const data =
      msg?.data_mensagem ||
      msg?.data ||
      msg?.createdAt ||
      msg?.created_at;

    const timestamp = new Date(data).getTime();
    return isNaN(timestamp) ? 0 : timestamp;
  }

  private getIdOrdenacao(msg: any): string {
    return String(
      msg?.id ??
      msg?.message_id ??
      msg?.client_temp_id ??
      ''
    );
  }

  private compararIdOrdenacao(a: any, b: any): number {
    const idA = this.getIdOrdenacao(a);
    const idB = this.getIdOrdenacao(b);

    if (idA === idB) {
      return 0;
    }

    const numA = Number(idA);
    const numB = Number(idB);

    const aNumerico = idA !== '' && !Number.isNaN(numA);
    const bNumerico = idB !== '' && !Number.isNaN(numB);

    if (aNumerico && bNumerico) {
      return numA - numB;
    }

    return idA.localeCompare(idB, undefined, { numeric: true, sensitivity: 'base' });
  }

  private compararMensagensOrdenacao(a: any, b: any): number {
    const dataA = this.getTimestamp(a);
    const dataB = this.getTimestamp(b);

    if (dataA !== dataB) {
      return dataA - dataB;
    }

    const idCompare = this.compararIdOrdenacao(a, b);
    if (idCompare !== 0) {
      return idCompare;
    }

    return 0;
  }

  private inserirMensagemOrdenada(msg: any): void {
    if (!Array.isArray(this.mensagensChat) || this.mensagensChat.length === 0) {
      this.mensagensChat = [msg];
      return;
    }

    this.mensagensChat.push(msg);
    this.scrollToBottom();
    this.cd.detectChanges();
  }


  private positionTemplatePreview(
    modalElement: HTMLElement,
    triggerLeft: number,
    triggerRight: number,
    triggerTop: number,
    triggerHeight: number
  ): void {
    const previewElement = this.templatePreviewPopover?.nativeElement as HTMLElement;

    if (!previewElement || !modalElement) {
      return;
    }

    const previewWidth = previewElement.offsetWidth || 340;
    const previewHeight = previewElement.offsetHeight || 200;
    const gap = 16;

    let arrowSide: 'left' | 'right' = 'right';
    let left = triggerLeft - previewWidth - gap;

    if (left < gap) {
      left = triggerRight + gap;
      arrowSide = 'left';
    }

    const maxLeft = Math.max(gap, modalElement.clientWidth - previewWidth - gap);
    left = Math.min(Math.max(left, gap), maxLeft);

    let top = triggerTop - 4;
    const maxTop = Math.max(gap, modalElement.clientHeight - previewHeight - gap);
    top = Math.min(Math.max(top, gap), maxTop);

    const arrowTop = Math.min(
      Math.max((triggerTop - top) + (triggerHeight / 2) - 6, 16),
      Math.max(16, previewHeight - 24)
    );

    this.templatePreview = {
      ...this.templatePreview,
      top,
      left,
      arrowTop,
      arrowSide
    };
  }

  scheduleHideTemplatePreview(): void {
    clearTimeout(this.templatePreviewHideTimeout);
    this.templatePreviewHideTimeout = setTimeout(() => {
      this.hideTemplatePreview();
    }, 320);
  }

  cancelHideTemplatePreview(): void {
    clearTimeout(this.templatePreviewHideTimeout);
  }

  hideTemplatePreview(): void {
    this.templatePreview = {
      visible: false,
      top: 0,
      left: 0,
      arrowTop: 18,
      arrowSide: 'right',
      template: null
    };
  }

  eventListenerTranscription = (event): void => {
    const target = event.target as HTMLElement;
    const seeMoreTag = target?.closest?.('.see-more-transcription') as HTMLElement;
    const seeMoreId = seeMoreTag?.id;
    const transcriptionItem = seeMoreId ? this.seeMoreTranscriptionItems[seeMoreId] : null;

    if (!seeMoreTag || !transcriptionItem) {
      return;
    }

    event.stopPropagation();
    event.preventDefault();

    const transcriptionTag = document.getElementById(transcriptionItem.transcriptionId);

    if (!transcriptionTag) {
      return;
    }

    const isExpanded = transcriptionTag.innerHTML === transcriptionItem.expandedText;

    transcriptionTag.innerHTML = isExpanded
      ? this.sanitizer.sanitize(SecurityContext.HTML, transcriptionItem.collapsedText)
      : this.sanitizer.sanitize(SecurityContext.HTML, transcriptionItem.expandedText);
    seeMoreTag.innerHTML = this.translate.instant(isExpanded ? 'VER_MAIS' : 'VER_MENOS');
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
    //document.removeAllListeners();
    this.unlisteners.forEach(unlisten => unlisten());
    document.removeEventListener('click', this.eventListenerTranscription);
    this.socketRealTime = null;
    this.fecharSockets();

    clearInterval(this.intervalNumerosDesconectados);
    clearTimeout(this.templatePreviewHideTimeout);
  }

  ngOnInit(): void {
    this.listaChats = [];
    this.buscaGuardaQntChatSalvo(false, true);
    this.carregarEnviosLocaisPendentesStorage();
    this.obterDados();

    if (!this.apenas_historico) {
      this.socketRealTime = this.websocketService.getSocket();
    }

    if (this.recebeStatusMessage) {
      this.statusSelecionado = this.recebeStatusMessage;
    }

    document.getElementsByTagName(this.selector)[0]["style"]["zoom"] = "0.85";
    this.verificaNovaMensagem();
    this.tokenData = this.tokenService.getAllInfos();
    this.loadChats();
    this.loadContadores();
    this.checkIntegrationGoogleSchedule();
    // comentado para analisar impacto e necessidade do evento de login do socket, DEIXAR ESSE TRECHO COMENTADO
    //this.loadContadores();
    // if (!this.historico_chat)
    //   this.websocketService.connectSocketChat(this.tokenData);
    // this.scrollToBottom();
    if (this.whatsAppContato) {
      // this.iniciaConversaWhatsApp(this.whatsAppContato);
      this.iniciaConversaWhatsAppUnificado(this.whatsAppContato);
      this.abrirChat(this.whatsAppContato);
    }

    if (this.historico_chat) {
      this.chatAtivoId = this.historico_chat?._id;

      if (
        this.historico_chat.status.toLowerCase() ===

        this.translate.instant("A_FAZER").toLowerCase()
      ) {
        this.statusSelecionado = 1;
      } else if (
        this.historico_chat.status.toLowerCase() ===
        this.translate.instant("FINALIZADO").toLowerCase()
      ) {
        this.statusSelecionado = 3;
      } else {
        this.statusSelecionado = 2;
      }
      this.abrirChat(this.historico_chat);
    }

    if (localStorage.getItem('abaChat')) {
      this.addOnTab = Number(localStorage.getItem('abaChat'));
    }

    this.verificaSolicitantesHabilitados();
    this.validarIntegracao();
    this.verificaIntegracao();

    if (!this.allowChatGPT) {
      setTimeout(() => {
        if (this.templatesChat && this.templatesChat.length > 0 && this.addOnTab === 1) {
          this.mudaAddOn(2);
        }
      }, 2000);
    }

    this.verificaNumerosDesconectados();
    this.intervalNumerosDesconectados = setInterval(() => {
      this.verificaNumerosDesconectados();
    }, 300000);
  }

  ngAfterViewInit() {
    if (!this.apenas_historico) {
      this.unlisteners.push(
        this.renderer.listen('document', 'nova_conversa', (data: any) => {
          console.log("Nova conversa recebida: ", data);
          this.checkContadores(data['detail']);
          this.verificaNovaMensagem();
        })
      );

      this.unlisteners.push(
        this.renderer.listen('document', 'nova_mensagem_chat_client', (data: any) => {
          console.log('nova mensagem chat client');
          const detail = data.detail ? data.detail : data;
          this.checkContadores(detail);
          this.updateChatList(detail);
        })
      );

      this.unlisteners.push(
        this.renderer.listen('document', 'nova_mensagem_chat_portal', (data: any) => {
          console.log('nova mensagem chat portal');
          const detail = data.detail ? data.detail : data;
          this.checkContadores(detail);
          this.updateChatList(detail);
        })
      );

      this.unlisteners.push(
        this.renderer.listen('document', 'receive', (data: any) => {
          console.log('nova mensagem');
          const detail = data.detail ? data.detail : data;
          this.checkContadores(detail);
          this.updateChatList(detail);
        })
      );

      this.unlisteners.push(
        this.renderer.listen('document', 'atualizacao_chat', (data: any) => {
          const detail = data.detail ? data.detail : data;

          if (detail?.chat_id && (detail?.tipo_encerramento || this.conversaEstaFinalizada(detail))) {
            this.tratarEncerramentoPorEvento({
              chatId: detail.chat_id,
              motivo: detail.tipo_encerramento,
              limparConversa: true,
            });
          }

          setTimeout(() => {
            if (!detail.enviado_por || detail.enviado_por !== 'tecnico') {
              this.loadChats();
              const atualizarIndicadorNovaMensagem = !this.deveIgnorarAtualizacaoChat(data['detail']);
              this.loadContadores(atualizarIndicadorNovaMensagem);
            }
          }, 500);
        })
      );

      this.unlisteners.push(
        this.renderer.listen('document', 'chat_finalizado', (data: any) => {
          const detail = data.detail ? data.detail : data;
          this.checkContadores(detail);
          this.loadChats();

          if (detail?.chat_id) {
            this.tratarEncerramentoPorEvento({
              chatId: detail.chat_id,
              motivo: detail.tipo || detail.tipo_encerramento,
              limparConversa: true,
            });
          }
        })
      );

      this.unlisteners.push(
        this.renderer.listen('document', 'msg_sent', (data: any) => {
          this.formatBodyMsg(data['detail'], 'interno');
          setTimeout(() => {
            this.goToBottom();
          }, 100);
        })
      );

      // o disconnect do socket.io depende do heartbeat (ping/pong) do engine.io,
      // que pode levar dezenas de segundos para detectar uma conexão morta.
      // os eventos nativos online/offline do navegador refletem a interface de
      // rede do SO quase instantaneamente, então usamos eles para atualizar
      // "conectado" sem esperar o timeout do socket.
      this.unlisteners.push(
        this.renderer.listen('window', 'offline', () => {
          const chatId = this.chatSelecionado?._id || this.chatAtivoId;
          if (chatId) {
            criaLogSessao('chat:browser-offline', { connected: false }, chatId);
          }
          this.conectado = false;
          this.reconectando = false;
        })
      );

      this.unlisteners.push(
        this.renderer.listen('window', 'online', () => {
          // só reconectar o socket da conversa ativa em atendimento: sockets de
          // conversas finalizadas, trocadas ou bloqueadas por "tooMany" têm sua
          // referência descartada (chatSelecionadoSocket = {}) nos respectivos
          // fluxos de encerramento, então não satisfazem esta checagem.
          if (
            this.chatSelecionadoSocket &&
            typeof this.chatSelecionadoSocket.connect === 'function' &&
            this.chatSelecionado?.status_id === 2
          ) {
            const chatId = this.chatSelecionado?._id || this.chatAtivoId;
            if (chatId) {
              criaLogSessao('chat:browser-online', { connected: this.chatSelecionadoSocket.connected }, chatId);
            }
            // não confiar em "connected": como o offline pode ter durado menos
            // que o ping timeout do engine.io, o socket ainda pode achar que
            // está conectado (estado "zumbi"). Forçamos disconnect + connect
            // para garantir um handshake novo e o disparo do evento "connect".
            this.reconectando = true;
            this.chatSelecionadoSocket.disconnect();
            this.chatSelecionadoSocket.connect();
          }
        })
      );

      document.addEventListener('click', this.eventListenerTranscription);
      setTimeout(() => {
        const modalButtons = this.elemRef.nativeElement.querySelectorAll('.modal button');

        modalButtons?.forEach((button: HTMLElement) => {
          if (button.hasAttribute('aria-hidden')) {
            this.renderer.removeAttribute(button, 'aria-hidden');
          }
        });
      }, 1000)
    }
  }

  verificaSolicitantesHabilitados(): void {
    this.newSubs = this.ticketService.getAberturaTicketPadrao()
      .subscribe({
        next: (results) => {
          this.solicitantes_habilitados = {
            solicitante_cliente: results.categorizacaoClientePadrao.solicitante_cliente,
            solicitante_contato: results.categorizacaoClientePadrao.solicitante_contato,
            solicitante_operador: results.categorizacaoClientePadrao.solicitante_operador
          };
        },
        error: (error) => console.error('verificaSolicitantesHabilitados', error)
      });
  }

  checkContadores(data) {
    if (data && data.contadores) {
      this.contadores = data.contadores;
    } else {
      this.loadContadores();
    }
  }

  updateChatList(chatData): void {
    let chatModificado;
    let indiceAntigoChatModificado;

    if (chatData && chatData.chat_id && chatData.msg) {
      this.listaChats?.forEach((chatEl, index) => {
        if (chatEl?._id === chatData.chat_id) {
          chatModificado = chatEl;
          indiceAntigoChatModificado = index;
        }
      });

      setTimeout(() => {
        if ((!this.chatSelecionado || this.chatSelecionado?._id !== chatData.chat_id) && chatModificado) {
          chatModificado.ultima_mensagem = chatData.msg;
          chatModificado.data_mensagem = this.tokenService.convertDateTimezoneToView(new Date());
        }

        if (chatModificado && chatData.enviado_por !== 'tecnico') {
          chatModificado.possui_mensagens_nao_lidas = true;
        }

        if (this.statusSelecionado === 2 && chatModificado) {
          this.listaChats.splice(indiceAntigoChatModificado, 1);
          this.listaChats.unshift(chatModificado);
        }

        this.cd.detectChanges();
        this.verificaRecebeuUltimaMsg(chatData);
      }, 800);
    } else {
      this.loadChats();
    }
  }

  setFirstMsgList(chat_id, last_msg): void {
    let _listChatsWithoutSelectedChat = (this.listaChats || []).filter(list => {
      return list?._id !== chat_id;
    });

    this.chatSelecionado.ultima_mensagem = last_msg;
    this.chatSelecionado.data_mensagem = this.tokenService.convertDateTimezoneToView(new Date());
    this.chatSelecionado.selecionado = true;

    if (this.statusSelecionado && this.isChatGrupo) {
      this.changeGrupo();
    } else if ((this.statusSelecionado && this.statusSelecionado !== this.chatSelecionado.status_id) || !this.statusSelecionado && !this.isChatGrupo) {
      this.changeStatus(this.chatSelecionado.status_id);
    } else {
      _listChatsWithoutSelectedChat.unshift(this.chatSelecionado);
      this.listaChats = _listChatsWithoutSelectedChat;
    }
  }

  private normalizarTextoMensagem(value: any): string {
    return (value || '')
      .toString()
      .replace(/\s+/g, ' ')
      .trim();
  }

  private criarChaveProtecaoEnvioDuplicado(chatId: string, message: any, tipo = 'texto'): string {
    return [
      chatId || '',
      tipo || '',
      this.normalizarTextoMensagem(message).toLowerCase()
    ].join('|');
  }

  private bloquearEnvioDuplicadoTemporario(chave: string): boolean {
    if (!chave) {
      return false;
    }

    const agora = Date.now();
    const ultimoEnvio = this.protecaoEnvioDuplicado.get(chave);

    if (ultimoEnvio && agora - ultimoEnvio < this.janelaProtecaoEnvioDuplicadoMs) {
      return true;
    }

    this.protecaoEnvioDuplicado.set(chave, agora);
    setTimeout(() => {
      if (this.protecaoEnvioDuplicado.get(chave) === agora) {
        this.protecaoEnvioDuplicado.delete(chave);
      }
    }, this.janelaProtecaoEnvioDuplicadoMs);

    return false;
  }

  private getChaveEnviosLocaisPendentesStorage(chatId: string): string {
    return `${this.chaveEnviosLocaisPendentesStorage}:${chatId}`;
  }

  private listarChavesEnviosLocaisPendentesStorage(): string[] {
    const prefixo = `${this.chaveEnviosLocaisPendentesStorage}:`;
    const chaves: string[] = [];

    for (let index = 0; index < localStorage.length; index++) {
      const chave = localStorage.key(index);
      if (chave?.startsWith(prefixo)) {
        chaves.push(chave);
      }
    }

    return chaves;
  }

  private extrairChatIdChaveEnviosLocaisPendentesStorage(chave: string): string {
    return chave.replace(`${this.chaveEnviosLocaisPendentesStorage}:`, '');
  }

  private deduplicarEnviosLocaisPendentes(pendencias: any[]): any[] {
    const pendenciasMap = new Map<string, any>();

    (pendencias || []).forEach((item) => {
      if (!item?.clientTempId) {
        return;
      }

      pendenciasMap.set(item.clientTempId, item);
    });

    return Array.from(pendenciasMap.values());
  }

  private carregarEnviosLocaisPendentesStorage(chatId?: string): void {
    try {
      const chatIds = chatId
        ? [chatId]
        : this.listarChavesEnviosLocaisPendentesStorage()
          .map(chave => this.extrairChatIdChaveEnviosLocaisPendentesStorage(chave))
          .filter(Boolean);

      if (!chatIds.length) {
        if (!chatId) {
          this.envioLocalPendente = [];
        }
        return;
      }

      let pendenciasAtuais = chatId
        ? (this.envioLocalPendente || []).filter(item => item?.chatId !== chatId || item?.status !== 'error')
        : [];

      chatIds.forEach((chatIdAtual) => {
        const dadosStorage = localStorage.getItem(this.getChaveEnviosLocaisPendentesStorage(chatIdAtual));
        if (!dadosStorage) {
          return;
        }

        const pendencias = JSON.parse(dadosStorage);
        if (!Array.isArray(pendencias)) {
          return;
        }

        pendenciasAtuais = pendenciasAtuais.concat(
          pendencias.map((item) => ({
            ...item,
            chatId: item?.chatId || chatIdAtual,
            status: item?.status || 'error',
            ignoreAtualizacaoChat: false,
            ignoreBuscaConversa: false
          }))
        );
      });

      this.envioLocalPendente = this.deduplicarEnviosLocaisPendentes(pendenciasAtuais);
    } catch (error) {
      console.error('carregarEnviosLocaisPendentesStorage', error);
      this.envioLocalPendente = [];
    }
  }

  private persistirEnviosLocaisPendentesStorage(chatId?: string): void {
    try {
      const chatIds = chatId
        ? [chatId]
        : Array.from(new Set([
          ...this.listarChavesEnviosLocaisPendentesStorage()
            .map(chave => this.extrairChatIdChaveEnviosLocaisPendentesStorage(chave))
            .filter(Boolean),
          ...(this.envioLocalPendente || []).map(item => item?.chatId).filter(Boolean)
        ]));

      chatIds.forEach((chatIdAtual) => {
        const pendenciasErro = (this.envioLocalPendente || [])
          .filter(item => item?.chatId === chatIdAtual && item?.status === 'error');
        const chaveStorage = this.getChaveEnviosLocaisPendentesStorage(chatIdAtual);

        if (!pendenciasErro.length) {
          localStorage.removeItem(chaveStorage);
          return;
        }

        localStorage.setItem(
          chaveStorage,
          JSON.stringify(pendenciasErro)
        );
      });
    } catch (error) {
      console.error('persistirEnviosLocaisPendentesStorage', error);
    }
  }

  private limparEnvioLocalPendenteSeNecessario(): void {
    this.envioLocalPendente = (this.envioLocalPendente || []).filter(item => {
      if (!item) {
        return false;
      }

      if (item.status === 'error' || item.status === 'sending') {
        return true;
      }

      const expirou = (Date.now() - item.createdAt) > this.janelaIgnorarEnvioLocalMs;
      const semPendencias = !item.ignoreAtualizacaoChat && !item.ignoreBuscaConversa;

      return !(expirou || semPendencias);
    });

    this.persistirEnviosLocaisPendentesStorage();
  }

  private criarEnvioLocalPendente(payload: any, clientTempId?: string): any {
    return {
      clientTempId: clientTempId || this.gerarTempIdMensagem(),
      chatId: payload?.chat_id,
      message: this.normalizarTextoMensagem(payload?.msg || payload?.body || payload?.message),
      createdAt: Date.now(),
      ignoreAtualizacaoChat: true,
      ignoreBuscaConversa: true,
      status: 'sending',
      payload: {
        ...payload,
        data: new Date()
      }
    };
  }

  private registrarEnvioLocalPendente(payload: any, clientTempId?: string): any {
    const pendencia = this.criarEnvioLocalPendente(payload, clientTempId);
    this.envioLocalPendente = (this.envioLocalPendente || [])
      .filter(item => item.clientTempId !== pendencia.clientTempId);
    this.envioLocalPendente.push(pendencia);
    this.persistirEnviosLocaisPendentesStorage(pendencia.chatId);
    return pendencia;
  }

  private atualizarEnvioLocalPendente(clientTempId: string, changes: any): any {
    const indice = (this.envioLocalPendente || []).findIndex(item => item.clientTempId === clientTempId);
    if (indice === -1) {
      return null;
    }

    this.envioLocalPendente[indice] = {
      ...this.envioLocalPendente[indice],
      ...changes
    };

    this.persistirEnviosLocaisPendentesStorage(this.envioLocalPendente[indice]?.chatId);
    return this.envioLocalPendente[indice];
  }

  private buscarEnvioLocalPendentePorMensagem(msg: any): any {
    const clientTempId = msg?.client_temp_id || msg?.id;
    if (!clientTempId) {
      return null;
    }

    return (this.envioLocalPendente || []).find(item => item.clientTempId === clientTempId) || null;
  }

  private removerEnvioLocalPendente(clientTempId: string): void {
    const pendencia = (this.envioLocalPendente || []).find(item => item.clientTempId === clientTempId);
    this.envioLocalPendente = (this.envioLocalPendente || [])
      .filter(item => item.clientTempId !== clientTempId);
    this.persistirEnviosLocaisPendentesStorage(pendencia?.chatId);
  }

  private marcarEnvioLocalComoEnviado(clientTempId: string): void {
    this.atualizarEnvioLocalPendente(clientTempId, {
      status: 'sent',
      errorMessage: null
    });
    this.limparEnvioLocalPendenteSeNecessario();
  }

  private marcarEnvioLocalComoErro(clientTempId: string, error: any): void {
    this.atualizarEnvioLocalPendente(clientTempId, {
      status: 'error',
      errorMessage: error?.error?.message || error?.message || this.translate.instant('ERROR_ENVIAR_MENSAGEM_CHAT'),
      ignoreAtualizacaoChat: false,
      ignoreBuscaConversa: false
    });
  }

  private deveIgnorarAtualizacaoChat(detail: any): boolean {
    this.limparEnvioLocalPendenteSeNecessario();

    const chatId = detail?.chat_id || detail?.id || this.chatSelecionado?._id;
    const pendencia = (this.envioLocalPendente || []).find(item =>
      item?.chatId === chatId &&
      item?.status !== 'error' &&
      item?.ignoreAtualizacaoChat
    );

    if (!pendencia) {
      return false;
    }

    pendencia.ignoreAtualizacaoChat = false;
    this.limparEnvioLocalPendenteSeNecessario();
    return true;
  }

  private deveIgnorarBuscaConversa(recebidoRealtime: any): boolean {
    this.limparEnvioLocalPendenteSeNecessario();

    const textoRecebido = this.normalizarTextoMensagem(
      recebidoRealtime?.msg || recebidoRealtime?.body || recebidoRealtime?.message
    );

    return (this.envioLocalPendente || []).some(item =>
      item?.chatId === recebidoRealtime?.chat_id &&
      item?.status !== 'error' &&
      item?.ignoreBuscaConversa &&
      item?.message === textoRecebido
    );
  }

  private gerarTempIdMensagem(): string {
    return `temp_msg_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  }

  private criarMensagemLocalListagem(msg: any, clientTempId?: string, errorMessage?: string): any {
    const respostaMessage =
      msg?.resposta_message ||
      this.respostaSelecionada?.body ||
      this.respostaSelecionada?.msg ||
      this.respostaSelecionada?.message ||
      this.respostaSelecionada?.link ||
      this.respostaSelecionada?.resposta_message ||
      null;

    const respostaMessageId =
      msg?.resposta_message_id ||
      this.respostaSelecionada?.whatsapp_id ||
      this.respostaSelecionada?.message_id ||
      null;

    const idTemporarioMensagem = clientTempId || msg?.client_temp_id || this.gerarTempIdMensagem();

    const mensagemLocal = {
      ...msg,
      id: idTemporarioMensagem,
      client_temp_id: idTemporarioMensagem,
      message_id: null,
      whatsapp_id: null,
      is_local: true,
      data_mensagem: msg?.data_mensagem || msg?.data || new Date(),
      body: msg?.body || msg?.msg,
      message: msg?.message || msg?.msg,
      status_mensagem: errorMessage ? 4 : (msg?.status_mensagem || 1),
      status_envio_id: errorMessage ? 5 : (msg?.status_envio_id || 1),
      erro_envio: errorMessage || msg?.erro_envio,
      error_msg: errorMessage || msg?.error_msg,
      error_msg_descricao: errorMessage || msg?.error_msg_descricao || msg?.error_msg,
      error_code: msg?.error_code || null,
      resposta_message: respostaMessage,
      resposta_message_id: respostaMessageId,
      resposta_enviado_por: msg?.resposta_enviado_por || this.respostaSelecionada?.enviado_por,
      local_storage_pendente: !!errorMessage
    };

    return mensagemLocal;
  }

  private buscarIndiceMensagemNaListagem(msg: any, clientTempId?: string, usarFallbackLocal = false): number {
    const mensagens = this.mensagensChat || [];

    if (clientTempId) {
      const indicePorTempId = mensagens.findIndex(mensagem => mensagem?.client_temp_id === clientTempId);
      if (indicePorTempId !== -1) {
        return indicePorTempId;
      }
    }

    const identificadores = [
      msg?.client_temp_id,
      msg?.id,
      msg?.message_id,
      msg?.whatsapp_id
    ].filter(Boolean);

    if (identificadores.length) {
      const indicePorIdentificador = mensagens.findIndex(mensagem => {
        const idsMensagem = [
          mensagem?.client_temp_id,
          mensagem?.id,
          mensagem?.message_id,
          mensagem?.whatsapp_id
        ].filter(Boolean);

        return identificadores.some(identificador => idsMensagem.includes(identificador));
      });

      if (indicePorIdentificador !== -1) {
        return indicePorIdentificador;
      }
    }

    if (!usarFallbackLocal) {
      return -1;
    }

    const mensagemLocal = [...mensagens]
      .map((mensagem, index) => ({ mensagem, index }))
      .reverse()
      .find(item => item.mensagem?.is_local && item.mensagem?.enviado_por === 'tecnico');

    return mensagemLocal ? mensagemLocal.index : -1;
  }

  private adicionarOuAtualizarMensagemLocalNaListagem(mensagemLocal: any, atualizarResumoLista = true): any {
    const mensagens = this.mensagensChat || [];
    let indiceMensagem = -1;

    if (mensagemLocal?.client_temp_id) {
      indiceMensagem = mensagens.findIndex(
        mensagem => mensagem?.client_temp_id === mensagemLocal.client_temp_id
      );
    }

    this.formatBodyMsg(mensagemLocal, 'interno');

    if (indiceMensagem !== -1) {
      this.mensagensChat[indiceMensagem] = {
        ...this.mensagensChat[indiceMensagem],
        ...mensagemLocal
      };
    } else if (this.mensagensChat?.length) {
      this.mensagensChat.push(mensagemLocal);
    } else {
      this.mensagensChat = [mensagemLocal];
    }

    if (atualizarResumoLista && this.chatSelecionado?._id) {
      this.chatAtivoId = this.chatSelecionado._id;
      this.setFirstMsgList(this.chatSelecionado._id, mensagemLocal.msg || mensagemLocal.body);
      this.locked = true;
      this.scrollToBottom();

      if (this.myScrollContainer?.nativeElement) {
        this.myScrollContainer.nativeElement.scrollTop =
          this.myScrollContainer.nativeElement.scrollHeight + 20;
      }

      this.atualizaDataInteracao(
        this.tokenService.convertDateTimezoneToView(new Date())
      );
    }

    return mensagemLocal;
  }

  private sincronizarEnviosLocaisPendentesChat(chatId: string): void {
    this.carregarEnviosLocaisPendentesStorage(chatId);

    const pendenciasChat = (this.envioLocalPendente || []).filter(item =>
      item?.chatId === chatId && item?.status === 'error' && item?.payload
    );

    pendenciasChat.forEach((pendencia) => {
      const mensagemLocal = this.criarMensagemLocalListagem(
        pendencia.payload,
        pendencia.clientTempId,
        pendencia.errorMessage
      );
      this.adicionarOuAtualizarMensagemLocalNaListagem(mensagemLocal, false);
    });
  }

  private substituirMsgListagem(msgAtualizada: any, clientTempId?: string): void {
    if (!msgAtualizada) {
      return;
    }

    const indiceMensagem = this.buscarIndiceMensagemNaListagem(msgAtualizada, clientTempId);
    if (indiceMensagem === -1) {
      return;
    }

    const mensagens = this.mensagensChat || [];
    const mensagem = mensagens[indiceMensagem];

    if (mensagem?.chat_id !== this.chatSelecionado?._id) {
      return;
    }

    const mensagemAnterior = indiceMensagem !== -1 ? this.mensagensChat[indiceMensagem] : null;
    const mensagemMesclada = {
      ...mensagemAnterior,
      ...msgAtualizada,
      client_temp_id: mensagemAnterior?.client_temp_id || clientTempId,
      is_local: false,
      resposta_message: msgAtualizada?.resposta_message || mensagemAnterior?.resposta_message,
      resposta_enviado_por: msgAtualizada?.resposta_enviado_por || mensagemAnterior?.resposta_enviado_por,
      resposta_message_id: msgAtualizada?.resposta_message_id || mensagemAnterior?.resposta_message_id
    };

    this.formatBodyMsg(mensagemMesclada, 'interno');

    if (indiceMensagem !== -1) {
      this.mensagensChat[indiceMensagem] = mensagemMesclada;
    } else if (this.mensagensChat?.length) {
      this.mensagensChat.push(mensagemMesclada);
    } else {
      this.mensagensChat = [mensagemMesclada];
    }

    if (clientTempId) {
      this.marcarEnvioLocalComoEnviado(clientTempId);
    }
  }

  private marcarErroMsgListagem(msgLocal: any, error: any): void {
    if (!msgLocal) {
      return;
    }

    const indiceMensagem = this.buscarIndiceMensagemNaListagem(
      msgLocal,
      msgLocal.client_temp_id,
      false
    );

    if (indiceMensagem === -1) {
      // grantindo a pesecistência do erro mesmo que a mensagem local não tenha sido encontrada na listagem 
      this.marcarEnvioLocalComoErro(
        msgLocal.client_temp_id,
        error
      );
      return;
    }

    const mensagens = this.mensagensChat || [];
    const mensagem = mensagens[indiceMensagem];

    if (mensagem?.chat_id !== this.chatSelecionado?._id) {
      // garantir persistência mesmo fora da tela
      this.marcarEnvioLocalComoErro(
        msgLocal.client_temp_id,
        error
      );
      return;
    }

    const errorMessage = error?.error?.message || error?.message || this.translate.instant('ERROR_ENVIAR_MENSAGEM_CHAT');
    const errorCode = error?.error?.code || error?.status || null;

    const mensagemErro = {
      ...this.mensagensChat[indiceMensagem],
      is_local: false,
      status_mensagem: 4,
      status_envio_id: 5,
      erro_envio: errorMessage,
      error_msg: errorMessage,
      error_msg_descricao: errorMessage,
      error_code: errorCode,
      local_storage_pendente: true
    };

    this.formatBodyMsg(mensagemErro, 'interno');
    this.mensagensChat[indiceMensagem] = mensagemErro;
    this.marcarEnvioLocalComoErro(msgLocal.client_temp_id, error);
  }

  obterMensagemEncerramento(tipoEncerramento: string): string {
    const chavesTraducaoPorTipo: Record<string, string> = {
      [TIPO_ENCERRAMENTO_CHAT.INATIVIDADE]: 'CHAT_ENCERRADO_INATIVIDADE',
      [TIPO_ENCERRAMENTO_CHAT.OPERADOR]: 'CHAT_ENCERRADO_OPERADOR',
      [TIPO_ENCERRAMENTO_CHAT.EXPEDIENTE]: 'CHAT_ENCERRADO_EXPEDIENTE',
      [TIPO_ENCERRAMENTO_CHAT.CHAT_FINALIZADO]: 'CHAT_FINALIZADO_NAO_ENVIAR',
    };
    const chaveTraducao = chavesTraducaoPorTipo[tipoEncerramento] || chavesTraducaoPorTipo[TIPO_ENCERRAMENTO_CHAT.CHAT_FINALIZADO];
    return this.translate.instant(chaveTraducao);
  }

  private obterStatusSituacaoPorMotivo(motivoEncerramento: string): number {
    const statusSituacaoPorMotivo: Record<string, number> = {
      [TIPO_ENCERRAMENTO_CHAT.INATIVIDADE]: STATUS_SITUACAO_CHAT.FINALIZADO_INATIVIDADE,
      [TIPO_ENCERRAMENTO_CHAT.EXPEDIENTE]: STATUS_SITUACAO_CHAT.FINALIZADO_EXPEDIENTE,
      [TIPO_ENCERRAMENTO_CHAT.OPERADOR]: STATUS_SITUACAO_CHAT.FINALIZADO_OPERADOR,
    };
    return statusSituacaoPorMotivo[motivoEncerramento] || STATUS_SITUACAO_CHAT.FINALIZADO_INATIVIDADE;
  }

  private obterMotivoPorStatusSituacao(statusSituacaoId: number): string {
    const motivoPorStatusSituacao: Record<number, string> = {
      [STATUS_SITUACAO_CHAT.FINALIZADO_INATIVIDADE]: TIPO_ENCERRAMENTO_CHAT.INATIVIDADE,
      [STATUS_SITUACAO_CHAT.FINALIZADO_EXPEDIENTE]: TIPO_ENCERRAMENTO_CHAT.EXPEDIENTE,
      [STATUS_SITUACAO_CHAT.FINALIZADO_OPERADOR]: TIPO_ENCERRAMENTO_CHAT.OPERADOR,
    };
    return motivoPorStatusSituacao[statusSituacaoId] || TIPO_ENCERRAMENTO_CHAT.INATIVIDADE;
  }

  private conversaEstaFinalizada(dadosConversa: any): boolean {
    return dadosConversa?.status === STATUS_CHAT.FINALIZADO
      || dadosConversa?.status_id === STATUS_CHAT.FINALIZADO
      || dadosConversa?.status_situacao_id === STATUS_SITUACAO_CHAT.FINALIZADO_INATIVIDADE
      || dadosConversa?.status_situacao_id === STATUS_SITUACAO_CHAT.FINALIZADO_EXPEDIENTE
      || dadosConversa?.status_situacao_id === STATUS_SITUACAO_CHAT.FINALIZADO_OPERADOR;
  }

  finalizarConversaAberta(params: {
    chatId: string;
    motivo: string;
    mensagem?: string;
    exibirNotificacao?: boolean;
  }): void {
    const { chatId, motivo, mensagem, exibirNotificacao = false } = params;
    const idConversaAberta = this.chatSelecionado?._id || this.chatSelecionado?.id;

    if (!idConversaAberta || idConversaAberta !== chatId) {
      return;
    }

    if (this.chatSelecionado?.status_id === STATUS_CHAT.FINALIZADO && this.chatSelecionado?.bloqueado) {
      return;
    }

    const statusSituacaoId = this.obterStatusSituacaoPorMotivo(motivo);
    const textoStatusEncerramento = mensagem || this.obterMensagemEncerramento(motivo);

    this.chatSelecionado = {
      ...this.chatSelecionado,
      status: 'Finalizado',
      status_id: STATUS_CHAT.FINALIZADO,
      status_situacao_id: statusSituacaoId,
      status_situacao: textoStatusEncerramento,
      bloqueado: true,
    };

    this.notificarChatFinalizado({ chat_id: chatId });
    this.removerMensagensOtimistasPendentes(chatId);
    this.respostaSelecionada = null;
    this.showEmoji = false;
    this.isAIExpanded = false;

    if (exibirNotificacao) {
      this.toastr.show(textoStatusEncerramento, '', environment.toastrConfig('warning'));
    }

    this.loadContadores(false);
    this.cd.detectChanges();
  }

  private removerMensagemOtimista(clientTempId: string): void {
    this.removerEnvioLocalPendente(clientTempId);
    const indiceMensagem = this.buscarIndiceMensagemNaListagem({}, clientTempId);

    if (indiceMensagem !== -1) {
      this.mensagensChat.splice(indiceMensagem, 1);
    }
  }

  private removerMensagensOtimistasPendentes(chatId: string): void {
    const pendenciasEnviando = (this.envioLocalPendente || []).filter(
      pendencia => pendencia?.chatId === chatId && pendencia?.status === 'sending'
    );

    pendenciasEnviando.forEach(pendencia => {
      this.removerMensagemOtimista(pendencia.clientTempId);
    });
  }

  private tratarErroEnvioChatFinalizado(erro: any, chatId: string, clientTempId?: string): boolean {
    const codigoErroHttp = erro?.status || erro?.error?.error_code;

    if (codigoErroHttp !== 409) {
      return false;
    }

    if (clientTempId) {
      this.removerMensagemOtimista(clientTempId);
    }

    const mensagemErro = erro?.error?.error_msg || erro?.error_msg || this.obterMensagemEncerramento(TIPO_ENCERRAMENTO_CHAT.CHAT_FINALIZADO);
    this.toastr.show(mensagemErro, '', environment.toastrConfig('warning'));
    this.finalizarConversaAberta({
      chatId,
      motivo: TIPO_ENCERRAMENTO_CHAT.CHAT_FINALIZADO,
      mensagem: mensagemErro,
    });

    return true;
  }

  private verificarStatusConversaAberta(chatId: string): void {
    if (!chatId || this.apenas_historico) {
      return;
    }

    this.newSubs = this.chatService.getChatConversa(chatId).subscribe({
      next: (msgs) => {
        const dadosConversa = msgs?.resp;

        if (this.conversaEstaFinalizada(dadosConversa)) {
          this.finalizarConversaAberta({
            chatId,
            motivo: this.obterMotivoPorStatusSituacao(dadosConversa?.status_situacao_id),
            mensagem: dadosConversa?.status_situacao,
          });
        }
      },
      error: (error) => console.error('verificarStatusConversaAberta', error)
    });
  }

  private tratarEncerramentoPorEvento(params: {
    chatId: string;
    motivo?: string;
    mensagem?: string;
    limparConversa?: boolean;
  }): void {
    const motivoEncerramento = params.motivo || TIPO_ENCERRAMENTO_CHAT.CHAT_FINALIZADO;

    this.finalizarConversaAberta({
      chatId: params.chatId,
      motivo: motivoEncerramento,
      mensagem: params.mensagem || this.obterMensagemEncerramento(motivoEncerramento),
    });

    const idConversaAberta = this.chatSelecionado?._id || this.chatSelecionado?.id;
    if (params.limparConversa && idConversaAberta && idConversaAberta === params.chatId) {
      this.chatAtivoId = "";
      this.chatSelecionado = null;
      delete this.mensagensChat;
      if (this.chatSelecionadoSocket) {
        this.chatSelecionadoSocket.close();
        this.chatSelecionadoSocket = {};
      }
    }
  }

  montarMsgListagem(msg: any, clientTempId?: string): any {
    const mensagemLocal = this.criarMensagemLocalListagem(msg, clientTempId);
    return this.adicionarOuAtualizarMensagemLocalNaListagem(mensagemLocal, true);
  }

  atualizaDataInteracao(data_mensagem): void {
    this.chatSelecionado.data_mensagem = data_mensagem;
  }

  verificaNovaMensagem() {
    if (localStorage.getItem("nova_mensagem")) {
      localStorage.removeItem("nova_mensagem");
    }
    console.log(`contadores: ${JSON.stringify(this.contadores)}`);

    let encodedObjectAsString: string = SimpleCrypt.encodeDefault(
      "szHYxd7tz",
      this.contadores && this.contadores.ag_atendimento > 0 ? "true" : "false"
    );
    localStorage.setItem("nova_mensagem", encodedObjectAsString);
  }

  openMic(chatSelecionado: any) {
    const modalRef = this.modalService.open(ChatViewerAudioComponent, {
      scrollable: false,
      size: "sm",
      keyboard: false,
      backdrop: "static",
    });

    modalRef.result.then((result) => {
      if (result) {
        var file = new File(
          [result.blob],
          "audio_" + new Date().getTime() + ".ogg",
          { type: 'audio/ogg', lastModified: Date.now() }
        );
        if (file && file.size <= 20000000) {
          this.newSubs = this.chatService.adicionarAnexoAudio(file, chatSelecionado._id).subscribe(
            async (res) => {
              if (chatSelecionado && chatSelecionado?._id === this.chatSelecionado?._id) {
                this.autoMsg(res, "anexo", chatSelecionado);
              } else {
                this.enviaAnexoOutroChat(chatSelecionado, res);
              }
            },
            error => console.error('openMic', error)
          );
        } else {
          this.toastr.show(
            this.translate.instant("ARQUIVO_NAO_SUPORTADO_OU_EXCEDEU_LIMITE"),
            "",
            environment.toastrConfig("warning")
          );
        }
      }
    });
  }
  checkStatusIdChamadoVinculado() {
    return this.chatSelecionado.chamado_vinculado.status_id === 1 || this.chatSelecionado.chamado_vinculado.status_id === 2
      || this.chatSelecionado.chamado_vinculado.status_id === 3
  }

  encerrarCriarTicket(chatSelecionado) {
    if (!chatSelecionado?.contato?.id) {
      this.abrirModalContato(true, 'encerrarCriar');
    } else {
      const modalRef = this.modalService.open(ModalAberturaTicketComponent, {
        backdrop: "static",
        windowClass: "modal-custom-milvus",
        keyboard: false,
        scrollable: false,
        size: "grande-encerrar-chat",
      });

      modalRef.componentInstance.chatData = chatSelecionado;

      modalRef.result.then((result) => {
        if (result && result.acao === "associar") {
          this.loadChats();
          this.chatAtivoId = chatSelecionado?._id;
          this.chatSelecionado.chamado_vinculado = result.chamado;
          this.chatSelecionado.chamado_id = result.chamado.id;
          if (this.chatSelecionado.is_chat_email) {
            setTimeout(() => {
              this.newSubs = this.chatService.obterChatTecnico(this.chatAtivoId).subscribe(
                (result) => {
                  if (result) {
                    this.chatSelecionado.chat_email_ui = result.chat?.chat_email_ui;
                  }
                },
                error => console.error('obterChatTecnico', error)
              );
            }, 1000);
          }
        } else if (result && result.acao === "finalizar") {
          this.chatSelecionadoSocket.connect();
          if (this.chatSelecionadoSocket.connected) {
            this.chatSelecionadoSocket.emit("chat_finalizado");
            this.chatSelecionadoSocket.close();
          } else {
            this.websocketService.finishChat(
              this.chatSelecionado,
              this.tokenData
            );
          }
          this.chatSelecionadoSocket = {};
          this.chatAtivoId = "";
          this.chatSelecionado = {};
          delete this.mensagensChat;
          this.chatSelecionado.status = "Finalizado";
          this.chatSelecionado.status_id = 3;
          this.isAIExpanded = false;
          this.chatAtivoId = chatSelecionado?._id;
          this.loadChats();
        }
      });
    }
  }

  openModalConversaZap() {
    const modalRef = this.modalService.open(ConversaZapComponent, {
      backdrop: "static",
      windowClass: "modal-custom-milvus",
      keyboard: false,
      scrollable: false,
      size: "grande",
    });

    modalRef.componentInstance.contatoCadastrado.subscribe(() => {
      if (this.chatSelecionado?._id) {
        this.buscarContatoDropdowns(this.chatSelecionado);
      }
    });

    modalRef.result.then((results) => {
      if (results) {
        this.loadChats();
        this.chatAtivoId = results._id;
        this.newSubs = this.chatService.obterChatTecnico(this.chatAtivoId).subscribe(
          (result) => {
            if (result) {
              this.abrirChat(result.chat);
            }
          },
          error => console.error('obterChatTecnico', error)
        );
      }
    });
  }

  verificaIntegracao() {
    this.newSubs = this.chatService.obterIntegracaoAtiva().subscribe(
      (result) => {
        if (result) {
          this.hasIntegracao = true;
          this.provider_id = result?.provider_id;
          this.integracaoGrupos = result?.integracao_grupos;
          this.operador = result?.operador;
        } else {
          this.hasIntegracao = false;
        }
      },
      error => console.error('verificaIntegracao', error)
    );
  }

  loadChats(filtro?: any): void {
    let dados = {
      filtro_body: {
        usuario_id: this.tokenData.id,
        utiliza_regra_minhas_filas: false,
        pesquisa: this.searchText
      },
    };

    if (!filtro && !this.gruposSelecionado) {
      if (this.statusSelecionado === 4) {
        filtro = 'somente_ag_fila';
      } else if (this.statusSelecionado === 5) {
        filtro = 'somente_ag_minha_resposta';
      }
    }

    if (filtro) {
      dados.filtro_body[filtro] = true;
      dados.filtro_body['status_chat_id'] = "__all__";
    } else {
      if (this.gruposSelecionado) {
        dados.filtro_body['somente_grupo'] = true;
        dados.filtro_body['status_chat_id'] = "__all__";
      } else {
        dados.filtro_body['status_chat_id'] = this.statusSelecionado
          ? this.statusSelecionado
          : "__all__";
      }
    }

    if (this.tokenData && this.tokenData.id) {
      this.getChatsLoadChats(dados);
    }
  }

  getChatsLoadChats(dados: any) {
    this.carregandoChats = true;
    this.newSubs = this.chatService
      .getChatsPorStatus(dados, 1, this.offSetChats)
      .subscribe((res) => {
        if (res && res.lista) {
          this.totalRegistrosChats = res.meta.paginate.total;
          this.chatPaginationProperties = res.meta.paginate;
          this.listaChats = res.lista;

          if (this.chatSelecionado) {
            let chatExistente = this.listaChats.findIndex(c => c?._id === this.chatSelecionado?._id);
            if (chatExistente !== -1) {
              const { contato_multiplos, contato_multiplos_tickets } = this.chatSelecionado;
              this.listaChats[chatExistente].selecionado = true;
              this.chatSelecionado = this.listaChats[chatExistente];

              if (this.chatSelecionado.contato_multiplos == null) {
                this.chatSelecionado.contato_multiplos = contato_multiplos;
              }
              if (this.chatSelecionado.contato_multiplos_tickets == null) {
                this.chatSelecionado.contato_multiplos_tickets = contato_multiplos_tickets;
              }
            }
          }

          if (this.chatIdRecebido) {
            let buscaChatRedirect = this.listaChats.filter(chat => chat._id === this.chatIdRecebido);
            if (buscaChatRedirect.length) {
              this.abrirChat(buscaChatRedirect[0]);
            }
          }

          this.scrollToSelectedChat();
        }

        this.carregandoChats = false;
        this.loadingScroll = false;
        this.loadingChats = false;
      }, error => {
        this.loadingChats = false;
        this.loadingScroll = false;
      });
  }

  loadContadores(atualizarIndicadorNovaMensagem = true): void {
    this.newSubs = this.chatService.getContadores().subscribe((rt) => {
      this.contadores = rt;

      if (atualizarIndicadorNovaMensagem) {
        this.verificaNovaMensagem();
      }
    }, error => console.error('loadContadores', error));
  }

  checkIntegrationGoogleSchedule(): void {
    this.newSubs = this.integrationService.getGoogleIntegrationSchedule().subscribe({
      next: (result) => {
        if (result?.hasOwnProperty('url')) {
          this.integrationGoogleSchedule.url = result.url;
          this.integrationGoogleSchedule.hasIntegrationGoogleSchedule = false;
        } else {
          this.integrationGoogleSchedule.url = '';
          this.integrationGoogleSchedule.hasIntegrationGoogleSchedule = true;
        }
        this.checkIntegrationOutlookSchedule();
      },
      error: () => {
        this.checkIntegrationOutlookSchedule();
      }
    });
  }

  checkIntegrationOutlookSchedule(): void {
    this.newSubs = this.integrationService.getOutlookIntegrationSchedule().subscribe({
      next: (result) => {
        if (result?.hasOwnProperty('url')) {
          this.integrationOutlookSchedule.url = result.url;
          this.integrationOutlookSchedule.hasIntegrationOutlookSchedule = false;
        } else {
          this.integrationOutlookSchedule.url = '';
          this.integrationOutlookSchedule.hasIntegrationOutlookSchedule = true;
        }
      },
      error: () => { }
    });
  }

  get hasIntegracaoAgenda(): boolean {
    return this.integrationGoogleSchedule.hasIntegrationGoogleSchedule || this.integrationOutlookSchedule.hasIntegrationOutlookSchedule;
  }

  enviarLinkReuniao(): void {
    if (!this.chatSelecionado || this.enviandoLinkReuniao) return;
    const tipo = this.integrationGoogleSchedule.hasIntegrationGoogleSchedule ? 'google' : 'outlook';
    this.enviandoLinkReuniao = true;
    this.newSubs = this.integrationService.criarLinkReuniaoAgenda({ tipo }).subscribe({
      next: (result) => {
        const textoErroApi =
          typeof result?.error_msg === 'string' && result.error_msg.trim().length > 0
            ? result.error_msg.trim()
            : null;
        if (result?.link) {
          const textoMensagemAtual = (this.mensagem ?? '').trim();
          this.mensagem = textoMensagemAtual ? `${textoMensagemAtual}\n${result.link}` : result.link;
          this.toastr.show(this.translate.instant('LINK_REUNIAO_PREENCHIDO_MENSAGEM'), '', environment.toastrConfig('success'));
        } else if (textoErroApi) {
          this.toastr.show(textoErroApi, '', environment.toastrConfig('danger'));
        } else {
          this.toastr.show(this.translate.instant('ERRO_CRIAR_LINK_REUNIAO'), '', environment.toastrConfig('danger'));
        }
        this.enviandoLinkReuniao = false;
      },
      error: () => {
        this.enviandoLinkReuniao = false;
      }
    });
  }

  formatDateList(input: any): any {
    if (input) {
      let dt = input.split(" ");
      let hr = dt[1].split(":");
      return hr[0] + ":" + hr[1];
    } else {
      return "";
    }
  }

  async abrirChat(chat: any, fromStartService?: boolean) {
    if (chat) {
      this.obterIntegracaoChatGPT();
      this.removeResposta();
      await this.buscarContatoDropdowns(chat);
      this.mensagem = "";
      let _oldChatId = (this.chatSelecionado) ? this.chatSelecionado?._id : null;
      const chat_id = chat._id;

      if ((_oldChatId !== chat_id) || fromStartService) {
        this.mensagensChat = [];
        this.trocandoChat = true;

        if (this.chatSelecionado) {
          this.chatSelecionado = {};
        }

        if (this.chatSelecionadoSocket && Object.keys(this.chatSelecionadoSocket).length > 0) {
          this.chatSelecionadoSocket.disconnect();
          this.chatSelecionadoSocket = {};
        }

        this.chatSelecionado = chat;
        chat.selecionado = true;
        this.isChatGrupo = this.chatSelecionado.is_grupo;

        if (this.listaChats) {
          this.listaChats?.forEach((element) => {
            if (element) {
              if (element?._id === chat_id) {
                element.selecionado = true;
              } else {
                element.selecionado = false;
              }
            }
          });
        }

        if (chat_id) {
          localStorage.setItem("@milvus:chatAberto", chat_id);
          this.chatAtivoId = chat_id;
          this.verificarExibicaoIconeHistoricoUsoBaseIa(chat_id);
          this.newSubs = this.chatService
            .getChatConversa(chat_id)
            .subscribe((msgs) => {
              this.provider_id = msgs?.resp?.provider_id;
              this.mensagensChat = msgs.resp.listaMensagens;
              this.sincronizarEnviosLocaisPendentesChat(chat_id);

              if (chat.is_chat_email && !chat.chat_email_ui) {
                this.newSubs = this.chatService.obterChatTecnico(chat_id).subscribe(
                  (result) => {
                    if (result) {
                      this.chatSelecionado.chat_email_ui = result.chat?.chat_email_ui;
                    }
                  },
                  error => console.error('obterChatTecnico', error)
                );
              }

              for (let msg of this.mensagensChat) {
                if (msg.body || msg.msg || msg.email_html_corpo) {
                  this.formatBodyMsg(msg, (msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico' || msg.is_tranferencia) ? 'interno' : 'externo');
                }
              }
              this.aplicarTranscricoesAntesDoHistorico();

              setTimeout(() => {
                this.goToBottom();
                this.scrollToBottom();
                this.lockedScroll = true;
                this.trocandoChat = false;
              }, 200);

              if (chat.possui_mensagens_nao_lidas) {
                this.chatService.mensagemChatLida(chat_id).subscribe((result) => {
                  chat.possui_mensagens_nao_lidas = false;
                }, error => console.error('abrirChat', error));
              }

              this.msgsTransferidas = [];
              if (msgs.resp.listaMensagensEncaminhadas) {
                this.msgsTransferidas = msgs.resp.listaMensagensEncaminhadas;

                for (let indiceMensagemTransferida = 0; indiceMensagemTransferida < this.msgsTransferidas.length; indiceMensagemTransferida++) {
                  const mensagemTransferida = this.msgsTransferidas[indiceMensagemTransferida];

                  if (mensagemTransferida.body || mensagemTransferida.msg || mensagemTransferida.email_html_corpo) {
                    this.prepararMensagemTransferida(mensagemTransferida);
                  }
                }
              }

              this.provider_id_conversa = msgs?.resp?.provider_id;
              this.msgSelecionadas = [];

              if (this.conversaEstaFinalizada(msgs?.resp)) {
                this.finalizarConversaAberta({
                  chatId: chat_id,
                  motivo: this.obterMotivoPorStatusSituacao(msgs?.resp?.status_situacao_id),
                  mensagem: msgs?.resp?.status_situacao,
                });
              }
            }, error => {
              this.trocandoChat = false;
              console.error('abrirChat', error);
            });
        }

        setTimeout(() => {
          if (this.trocandoChat === true) {
            this.trocandoChat = false;
          }
        }, 6000);

        if (chat.status_id === 2 && !this.apenas_historico) {
          const socket_new = await this.websocketService.connectChat(
            chat,
            this.tokenData
          );
          this.chatSelecionadoSocket = socket_new;
          this.tooMany = this.websocketService.tooMany;
          this.conectado = this.chatSelecionadoSocket.connected;
          let chatSocketId = this.chatSelecionadoSocket.id;

          this.chatSelecionadoSocket.on("receive", (msg: any, ack?: Function) => {
            try {
              criaLogSessao('chat:receive', msg, chat_id);
              if (msg) {
                this.notificarAtualizar(msg);
                if (msg && chat_id) {
                  this.chatService.mensagemChatLida(chat_id).subscribe((result) => {
                    chat.possui_mensagens_nao_lidas = false;
                    chat.ultima_mensagem = msg.msg;
                    if ((msg.tipo !== 'anexo' && !msg.msg_legenda) || (msg.tipo === 'anexo' && !msg.msg_legenda)) {
                      let formatedHour;
                      if (msg.data_mensagem) {
                        formatedHour = moment.utc(msg.data_mensagem).local().format('DD/MM/YYYY HH:mm:ss');
                      } else {
                        formatedHour = moment(msg.data_mensagem).local().format('DD/MM/YYYY HH:mm:ss');
                      }
                      chat.data_mensagem = formatedHour;
                    }
                  }, error => console.error('recebeMsgChat', error));

                  if (msg.enviado_por !== 'tecnico') {
                    const payload = {
                      chat_id: chat._id,
                      enviado_por: 'cliente'
                    };

                    this.newSubs = this.chatService.marcarLidoChatInterno(payload)
                      .subscribe({
                        next: () => {
                          this.marcarComoLidoEvento();
                        }, error: (error) => console.error('marcarLidoChatInterno', error)
                      });
                  }
                }

                if (this.templatesSomenteMeta && msg.enviado_por === 'cliente') {
                  setTimeout(() => {
                    this.obterTemplatesChat();
                  }, 500);
                }
                this.tooMany = this.websocketService.tooMany;

                if (ack) {
                  ack({
                    status: 'received',
                    messageId: msg.message_id,
                    receivedAt: new Date().toISOString()
                  });
                }

                if (msg?.status_chat === STATUS_CHAT.FINALIZADO && msg?.chat_id) {
                  this.tratarEncerramentoPorEvento({
                    chatId: msg.chat_id,
                    motivo: TIPO_ENCERRAMENTO_CHAT.INATIVIDADE,
                    mensagem: msg.msg,
                  });
                }
              }
            } catch (error) {
              criaLogSessao('chat:receive-error', msg, chat_id, error);
              if (ack) {
                ack({
                  status: 'error',
                  messageId: msg.message_id,
                  error: String(error)
                });
              }
            }
          });

          this.chatSelecionadoSocket.on("connect", () => {
            this.conectado = this.chatSelecionadoSocket.connected;
            this.reconectando = false;
            this.tooMany = this.websocketService.tooMany;
            chatSocketId = this.chatSelecionadoSocket.id;
            criaLogSessao('chat:connect', { socketId: chatSocketId, connected: this.conectado }, chat_id);
            this.verificarStatusConversaAberta(chat_id);
          });

          this.chatSelecionadoSocket.on("connected", () => {
            this.tooMany = this.websocketService.tooMany;
            this.tooManyMsg = undefined;
            this.tentativas = 0;
            criaLogSessao('chat:connected', { socketId: this.chatSelecionadoSocket.id, connected: this.chatSelecionadoSocket.connected }, chat_id);
            console.log("Chat - " + this.conectado);
          });

          this.chatSelecionadoSocket.on("disconnect", (reason: string) => {
            this.conectado = false;
            criaLogSessao('chat:disconnect', { socketId: chatSocketId, connected: this.conectado, reason }, chat_id);
            console.log("Chat - " + this.conectado);

            // 'io server disconnect': o servidor encerrou a conexão deliberadamente
            // (ex.: sobrecarga derrubando conexões) e, ao contrário dos demais motivos
            // (transport close/error, ping timeout), o socket.io NÃO tenta reconectar
            // sozinho nesse caso. Os fluxos de desconexão intencional deste componente
            // (chat finalizado, troca de conversa, bloqueio por tooMany) descartam a
            // referência do socket (chatSelecionadoSocket = {}) antes deste timeout
            // disparar, então a checagem abaixo não reabre esses casos. O atraso evita
            // martelar um servidor já sobrecarregado.
            if (reason === 'io server disconnect' && this.chatSelecionado?.status_id === 2) {
              setTimeout(() => {
                if (
                  this.chatSelecionadoSocket === socket_new &&
                  !this.chatSelecionadoSocket.connected &&
                  this.chatSelecionado?.status_id === 2
                ) {
                  criaLogSessao('chat:server-disconnect-reconnect', { socketId: chatSocketId }, chat_id);
                  this.reconectando = true;
                  this.chatSelecionadoSocket.connect();
                }
              }, 10000);
            }
          });

          this.chatSelecionadoSocket.on("tooMany", (msg: any) => {
            criaLogSessao('chat:tooMany', msg, chat_id);
            this.conectado = false;
            this.chatSelecionadoSocket.close();
            this.chatSelecionadoSocket = {};
            this.tooManyMsg = this.translate.instant('CONECTADO_OUTRA_ABA');
          });

          this.chatSelecionadoSocket.on('reconnect', () => {
            this.tentativas = 0;
            this.conectado = true;
            this.reconectando = false;
            chatSocketId = this.chatSelecionadoSocket.id;
            criaLogSessao('chat:reconnect', { socketId: chatSocketId, connected: this.conectado }, chat_id);
            this.verificarStatusConversaAberta(chat_id);
            console.log("Chat - " + this.conectado);
          });

          this.chatSelecionadoSocket.on('reconnecting', (attempt) => {
            this.reconectando = true;
            this.tentativas = attempt;
            console.log("Chat - " + this.conectado);
          });

          this.chatSelecionadoSocket.on("chat_finalizado", (data: any) => {
            this.tratarEncerramentoPorEvento({
              chatId: data?.chat_id || chat_id,
              motivo: data?.tipo,
            });
          });

          this.chatSelecionadoSocket.on("resp_msg_sent", (msg: any) => {
            if (this.provider_id === 4) {
              const msgIndex = this.buscarIndiceMensagemNaListagem(msg, undefined);

              if (msgIndex !== -1) {
                this.mensagensChat[msgIndex].message_id = this.mensagensChat[msgIndex].message_id || msg.message_id;
                this.mensagensChat[msgIndex].status_mensagem = msg.status_mensagem;
                this.mensagensChat[msgIndex].error_msg = msg.error_msg;
                this.mensagensChat[msgIndex].error_code = msg.error_code;

                const isErro131047 = msg.error_code === '131047' || msg.error_code === 131047;
                this.formatBodyMsg(this.mensagensChat[msgIndex], 'interno', isErro131047);

                setTimeout(() => {
                  this.goToBottom();
                }, 100);
              }

              if (msg.status_mensagem === 4 && msg.showModal_template && !this.isModalOpen) {
                this.abrirModalEnvioWhatsApp(true);
              }

            } else {
              if (msg.message_id) {
                const msgIndex = this.buscarIndiceMensagemNaListagem(msg, undefined);

                if (msgIndex !== -1) {
                  this.mensagensChat[msgIndex].message_id = this.mensagensChat[msgIndex].message_id || msg.message_id;
                  this.mensagensChat[msgIndex].status_mensagem = msg.status_mensagem;
                  this.mensagensChat[msgIndex].status_envio_id = msg.status_envio_id;
                  this.mensagensChat[msgIndex].error_msg = msg.error_msg;
                  this.mensagensChat[msgIndex].error_code = msg.error_code;

                  const isErro131047 = msg.error_code === '131047' || msg.error_code === 131047;
                  this.formatBodyMsg(this.mensagensChat[msgIndex], 'interno', isErro131047);

                  setTimeout(() => {
                    this.goToBottom();
                  }, 100);
                }
              } else if (msg.data_leitura) {
                this.mensagensChat = this.mensagensChat.map(m => {
                  // marca como lida tudo do chat até aquele momento
                  if (
                    m.data_mensagem && msg.data_leitura &&
                    new Date(m.data_mensagem).getTime() <= new Date(msg.data_leitura).getTime() &&
                    msg.chat_id === chat_id &&
                    m.status_envio_id === 3 && //ENTREGUE
                    m.enviado_por === 'tecnico'
                  ) {
                    m.status_mensagem = msg.status_mensagem;
                    m.status_envio_id = msg.status_envio_id;
                    m.error_msg = msg.error_msg;
                    m.error_code = msg.error_code;
                    const isErro131047 = msg.error_code === '131047' || msg.error_code === 131047;
                    this.formatBodyMsg(m, 'interno', isErro131047);
                  }

                  return m;
                })
                setTimeout(() => {
                  this.goToBottom();
                }, 100);

              }
            }
          });

          // MIL-30097: transcrição feita em segundo plano ao abrir o histórico; atualiza só a mensagem, no lugar
          this.chatSelecionadoSocket.on("mensagem_transcrita", (msg: any) => {
            if (!this.aplicarMensagemTranscrita(msg)) {
              this.transcricoesAntesDoHistorico.push(msg);
            }
          });

          this.chatSelecionadoSocket.on("mensagens_visualizadas", (msg: any) => {
            setTimeout(() => {
              this.mensagensChat.forEach(m => {
                if (m.enviado_por === 'tecnico') {
                  m.status_mensagem = 2;
                  this.formatBodyMsg(m, 'interno');
                }
              });
            }, 500);
          });

          this.chatSelecionadoSocket.on('startChat', (data) => {
            criaLogSessao('chat:startChat', data, chat_id);
            const payload = {
              chat_id: chat._id,
              enviado_por: 'cliente'
            };

            this.newSubs = this.chatService.marcarLidoChatInterno(payload)
              .subscribe({
                next: () => {
                  this.marcarComoLidoEvento();
                }, error: (error) => console.error('marcarLidoChatInterno', error)
              });
          });
        }

        if (this.allowChatGPT) {
          this.closeChatGPTModal = true;
        }

        setTimeout(() => {
          this.obterTemplatesChat();
        }, 1000);
      } else {
        if (this.allowChatGPT) {
          this.closeChatGPTModal = true;
        }

        setTimeout(() => {
          this.obterTemplatesChat();
        }, 1000);
      }
    }
  }

  abrirChatFromView(chat: any): void {
    if (chat && (!this.chatSelecionado || !this.chatSelecionado._id || chat._id !== this.chatSelecionado._id) && !this.trocandoChat) {
      this.abrirChat(chat);
    }
  }

  abrirModalEnvioWhatsApp(isToShowSpecificMessageFromMeta: boolean, msg?: any) {
    if (this.isModalOpen && (!msg || msg.error_code !== '131047' && msg.error_code !== 131047)) {
      return;
    }

    if (msg && this.chatSelecionado &&
      msg.chat_id !== this.chatSelecionado.id &&
      msg.chat_id !== this.chatSelecionado._id &&
      msg.error_code !== '131047' && msg.error_code !== 131047) {
      return;
    }

    this.isModalOpen = true;
    this.newSubs = this.chatService.obterIntegracaoAtiva()
      .subscribe({
        next: (results) => {
          if (!results) {
            this.isModalOpen = false;
            Swal.fire({
              title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_INTEGRACAO'),
              icon: 'info',
              confirmButtonText: 'Ok',
              position: 'top'
            });
            return;
          }

          const modalRef = this.modalService.open(ModalMsgStartChatWhatsappComponent, {
            scrollable: false,
            windowClass: 'modal-custom-milvus modal-erro-131047',
            size: 'lg',
            keyboard: true,
            backdrop: 'static',
          });

          const data = {
            provider_id: this.provider_id_conversa,
            chat_id: this.chatSelecionado?._id,
            fila_atendimento: this.chatSelecionado?.fila_atendimento,
            contato: this.chatSelecionado?.contato?.descricao,
            empresa: this.nomeEmpresa,
            operador: this.operador,
            protocolo: this.chatSelecionado?.protocolo,
            ...results
          };

          modalRef.componentInstance.data = data;
          modalRef.componentInstance.templateMessage = true;
          modalRef.componentInstance.isToShowSpecificMessageFromMeta = isToShowSpecificMessageFromMeta;

          if (msg) {
            modalRef.componentInstance.mensagemErro = msg;
            modalRef.componentInstance.isErro131047 = true;
          }

          modalRef.componentInstance.contatoSelecionado = this.contatoSelecionado || this.chatSelecionado;

          modalRef.result.then(
            (result) => {
              if (result) {
                if (result.template_name && result.template_content) {
                  this.enviarMsg(true, result);
                } else {
                  this.mensagem = result.template_content;
                  this.enviarMsg();
                }
              }
              this.isModalOpen = false;
            },
            (reason) => {
              this.isModalOpen = false;
            }
          );
        }, error: (error) => {
          this.isModalOpen = false;
          console.error('abrirModalEnvioWhatsApp', error);
        }
      });
  }

  private aplicarMensagemTranscrita(msg: any): boolean {
    const msgIndex = this.buscarIndiceMensagemNaListagem(msg, undefined);

    if (msgIndex === -1) {
      return false;
    }

    const mensagem = this.mensagensChat[msgIndex];
    mensagem.transcricao_audio = msg.transcricao_audio || mensagem.transcricao_audio;
    mensagem.resumo_audio = msg.resumo_audio || mensagem.resumo_audio;
    mensagem.transcricao_imagem = msg.transcricao_imagem || mensagem.transcricao_imagem;
    this.formatBodyMsg(mensagem, (mensagem.enviado_por === 'robo' || mensagem.enviado_por === 'tecnico' || mensagem.is_tranferencia) ? 'interno' : 'externo');
    return true;
  }

  private aplicarTranscricoesAntesDoHistorico(): void {
    this.transcricoesAntesDoHistorico.forEach(msg => this.aplicarMensagemTranscrita(msg));
    this.transcricoesAntesDoHistorico = [];
  }

  loadChatMessages(chat_id: string) {
    if (!chat_id) {
      return;
    }

    this.newSubs = this.chatService
      .getChatConversa(chat_id)
      .subscribe((msgs) => {
        this.provider_id = msgs?.resp?.provider_id;
        msgs?.resp?.listaMensagens?.forEach(msgLoaded => {
          if (this.mensagensChat?.length && !this.mensagensChat.find(msgLocal => msgLocal.id === msgLoaded.id)) {
            this.mensagensChat.push(msgLoaded);
          }
        });

        this.sincronizarEnviosLocaisPendentesChat(chat_id);

        this.mensagensChat?.forEach(msg => {
          if (msg.body || msg.msg || msg.email_html_corpo) {
            this.formatBodyMsg(msg, (msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico' || msg.is_tranferencia) ? 'interno' : 'externo');
          }
        });
        this.aplicarTranscricoesAntesDoHistorico();
        setTimeout(() => {
          this.goToBottom();
          this.scrollToBottom();
        }, 100);

        if (this.conversaEstaFinalizada(msgs?.resp)) {
          this.finalizarConversaAberta({
            chatId: chat_id,
            motivo: this.obterMotivoPorStatusSituacao(msgs?.resp?.status_situacao_id),
            mensagem: msgs?.resp?.status_situacao,
          });
        }
      }, error => console.error('getChatConversa', error));
  }

  notificarAtualizar(msg: any) {
    if (msg.chat_id === this.chatSelecionado?._id && (msg.enviado_por !== 'tecnico' || (msg.enviado_por === 'tecnico' && this.chatSelecionado?.is_grupo))) {
      this.formatBodyMsg(msg, 'externo', true);
      this.inserirMensagemOrdenada(msg);

      this.locked = true;
      this.scrollToBottom();
      this.cd.detectChanges();
    }

    this.chatAtivoId = this.chatSelecionado?._id ? this.chatSelecionado?._id : "";
    setTimeout(() => {
      this.verificaRecebeuUltimaMsg(msg);
    }, 3000);
  }

  abrirInfoContato(chat: any) {
    const modalRef = this.modalService.open(DetalhesContatoChatComponent, {
      scrollable: false,
      windowClass: "modal-custom-milvus",
      size: "medio",
      keyboard: false,
      backdrop: "static",
    });
    modalRef.componentInstance.chatData = chat;
    modalRef.result.then((result) => { });
  }

  associarContato(chat: any) {
    this.chatAtivoId = chat?._id;
    const modalRef = this.modalService.open(ModalChatContatoComponent, {
      scrollable: false,
      windowClass: "modal-custom-milvus",
      size: "grande",
      keyboard: false,
      backdrop: "static",
    });
    modalRef.componentInstance.chatData = chat;
    modalRef.result.then((result) => {
      if (result) {
        this.loadChats();
        this.chatSelecionado.nome_contato = result.descricao;
        this.chatSelecionado.telefone = result.telefone;
      }
    });
  }

  async enviarMsg(isTemplate = false, template = null) {
    if ((this.mensagem && !isTemplate) || (isTemplate && template.template_content)) {
      let messageContent = isTemplate ? template.template_content : this.mensagem;
      let fixedMessage = this.normalizarTextoMensagem(messageContent);

      if (fixedMessage !== "" && fixedMessage !== undefined) {
        const chaveProtecaoDuplicado = this.criarChaveProtecaoEnvioDuplicado(
          this.chatSelecionado?._id,
          fixedMessage,
          isTemplate ? 'template' : 'texto'
        );

        if (this.bloquearEnvioDuplicadoTemporario(chaveProtecaoDuplicado)) {
          return;
        }

        this.reenviarMensagem = messageContent;


        let resposta_message_id = null;
        if (this.respostaSelecionada && this.respostaSelecionada.whatsapp_id) {
          resposta_message_id = this.respostaSelecionada.whatsapp_id;
        } else if (this.respostaSelecionada && this.respostaSelecionada.message_id) {
          resposta_message_id = this.respostaSelecionada.message_id;
        }


        var _msg = {
          user: this.tokenData?.nome,
          enviado_por: "tecnico",
          chat_id: this.chatSelecionado._id,
          tipo: "texto",
          img: this.tokenData?.foto,
          resposta_message_id,
          message_id: this.respostaSelecionada ? this.respostaSelecionada.message_id : null,
          msg: messageContent,
          token_widget: this.chatSelecionado.widget.token_widget,
          nome: this.tokenData?.nome,
          data: new Date(),
          message: messageContent,
          body: messageContent,
          origem: 'gestor',
          formatedBody: null
        };

        if (isTemplate && template.template_name) {
          _msg['template_name'] = template.template_name;
          _msg['template_content'] = template.template_content;
          _msg['variaveis_content'] = template.variaveis_content;
          _msg['variaveis_header'] = template.variaveis_header;
          _msg['variaveis_descricao_original'] = template.variaveis_descricao_original;
          _msg['variaveis_header_original'] = template.variaveis_header_original;
          _msg['language'] = template.language;
        }

        const pendencia = this.registrarEnvioLocalPendente(_msg);
        const msgLocal = this.montarMsgListagem(_msg, pendencia.clientTempId);
        this.mensagem = "";
        this.respostaSelecionada = null;

        this.chatService.enviarMsg(_msg)
          .subscribe({
            next: (results) => {
              if (results?.ultima_mensagem) {
                this.substituirMsgListagem(results?.ultima_mensagem, msgLocal?.client_temp_id);
              }
              setTimeout(() => {
                if (this.chatBox && this.chatBox.nativeElement) {
                  this.chatBox.nativeElement.focus();
                }
              }, 100);
            }, error: (error) => {
              if (this.tratarErroEnvioChatFinalizado(error, _msg.chat_id, msgLocal?.client_temp_id)) {
                return;
              }
              this.marcarErroMsgListagem(msgLocal, error);
              setTimeout(() => {
                if (this.chatBox && this.chatBox.nativeElement) {
                  this.chatBox.nativeElement.focus();
                }
              }, 100);
            }
          });

        // Comentado caso necessário rollback
        // this.websocketService.addSocketMsgChat(_msg, this.chatSelecionadoSocket, (mesagemAtualizada) => {
        //   console.log('Mensagem retornada:', mesagemAtualizada);
        // this.mudouStatusMsg(mesagemAtualizada);
        // this.formatBodyMsg(mesagemAtualizada, 'interno');
        // if (this.mensagensChat.length) {
        //   this.mensagensChat.push(mesagemAtualizada);
        // } else {
        //   this.mensagensChat = [mesagemAtualizada];
        // }
        // this.chatAtivoId = this.chatSelecionado._id;
        // this.setFirstMsgList(this.chatSelecionado._id, this.mensagem);
        // this.mensagem = "";
        // this.locked = true;
        // this.myScrollContainer.nativeElement.scrollTop =
        //   this.myScrollContainer.nativeElement.scrollHeight + 20;
        // this.atualizaDataInteracao(
        //   this.tokenService.convertDateTimezoneToView(new Date())
        // );
        // });
      }
    }
  }

  addEmoji(emojidata) {
    this.mensagem = this.mensagem
      ? this.mensagem + emojidata.emoji.native
      : emojidata.emoji.native;
  }

  close(result?) {
    this.tokenData = {};
    this.fecharSockets();
    localStorage.setItem("@milvus:chatAberto", "");
    this.activeModal.close();
  }

  fecharSockets(): void {
    this.socketsAbertos = [];
    if (
      this.chatSelecionadoSocket &&
      this.chatSelecionadoSocket.hasOwnProperty("connected")
    ) {
      this.chatSelecionadoSocket.disconnect();
      this.chatSelecionadoSocket = {};
    }
  }

  scrollToBottom(): void {
    if (this.locked) {
      try {
        this.myScrollContainer.nativeElement.scrollTop =
          this.myScrollContainer.nativeElement.scrollHeight + 20;
      } catch (err) { }
    }
  }

  goToBottom(): void {
    this.myScrollContainer.nativeElement.scroll({
      top: this.myScrollContainer.nativeElement.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  }

  onScroll(event) {
    this.locked = false;
  }

  splitName(name): string {
    if (name) {
      var _nome = name.split(" ");
      if (_nome.length > 1) {
        return _nome[0].charAt(0) + _nome[1].charAt(0);
      } else {
        return name.charAt(0);
      }
    } else return '';
  }

  getTooMany(): void {
    return this.websocketService.tooMany;
  }

  abrirModalFinalizar(chat: any): void {
    const associarObrigatorio =
      chat?.fila_atendimento?.associar_chamado_obrigatorio === true;
    const chatSemChamado = !chat?.chamado_id && !chat?.chamado_vinculado;
    if (
      associarObrigatorio &&
      chatSemChamado &&
      (this.solicitantes_habilitados.solicitante_cliente || this.solicitantes_habilitados.solicitante_contato)
    ) {
      Swal.fire({
        title: this.translate.instant("AVISO"),
        text: this.translate.instant("INFO_CHAT_DEVE_ESTAR_ANEXADO"),
        icon: "warning",
        showCancelButton: false,
        confirmButtonText: "OK",
        position: 'top'
      });
    } else {
      if (!chat.contato?.id) {
        this.abrirModalContato(true, 'encerrar');
      } else {
        const modalRef = this.modalService.open(ChatFinalizarComponent, {
          scrollable: false,
          windowClass: "modal-custom-milvus",
          size: "medio",
          keyboard: false,
          backdrop: "static",
        });

        modalRef.componentInstance.chatData = chat;
        modalRef.componentInstance.socketChat = this.chatSelecionadoSocket;
        modalRef.componentInstance.solicitantes_habilitados = this.solicitantes_habilitados;

        modalRef.result.then((result) => {
          if (result === "finalizado") {
            this.chatSelecionadoSocket.connect();
            if (this.chatSelecionadoSocket.connected) {
              this.chatSelecionadoSocket.emit("chat_finalizado");
              this.chatSelecionadoSocket.close();
            } else {
              this.websocketService.finishChat(
                this.chatSelecionado,
                this.tokenData
              );
            }
            this.chatSelecionadoSocket = {};
            this.chatAtivoId = "";
            this.chatSelecionado = null;
            delete this.mensagensChat;
          }
          this.listaChats = [];
          this.loadChats();
        });
      }
    }
  }

  transferirChat(chatSelecionado): void {
    const modalRef = this.modalService.open(ModalTransferenciaTicketComponent, {
      scrollable: false,
      windowClass: "modal-custom-milvus",
      size: "lg",
      keyboard: false,
      backdrop: "static",
    });

    modalRef.componentInstance.chatData = chatSelecionado;
    modalRef.componentInstance.msgSelecionadas = this.msgSelecionadas.map(m => m.id);
    modalRef.componentInstance.mensagensChat = this.mensagensChat.filter(m => (m.enviado_por !== 'robo' && !m.is_tranferencia)).map(m => m.id);

    modalRef.result.then((result) => {
      if (result) {
        if (this.chatSelecionadoSocket && this.conectado) {
          this.chatSelecionadoSocket.close();
          this.chatSelecionadoSocket = {};
        }

        this.chatAtivoId = "";
        this.chatSelecionado = {};
        delete this.chatSelecionado;
        delete this.mensagensChat;
        this.listaChats = [];
        this.loadChats();
      }
    });
  }

  conciliarTicket(chatSelecionado): void {
    if (!chatSelecionado?.contato?.id) {
      this.abrirModalContato(true, 'associar');
    } else {
      const modalRef = this.modalService.open(ModalChatConciliarComponent, {
        scrollable: false,
        windowClass: "modal-custom-milvus",
        size: "lg",
        keyboard: false,
        backdrop: "static",
      });

      modalRef.componentInstance.chatData = chatSelecionado;

      modalRef.result.then((result) => {
        if (result) {
          this.chatAtivoId = chatSelecionado?._id;
          this.chatSelecionado.chamado_vinculado = result;
          this.chatSelecionado.chamado_id = result.id;
          this.loadChats();
          if (this.chatSelecionado.is_chat_email) {
            setTimeout(() => {
              this.newSubs = this.chatService.obterChatTecnico(this.chatAtivoId).subscribe(
                (result) => {
                  if (result) {
                    this.chatSelecionado.chat_email_ui = result.chat?.chat_email_ui;
                  }
                },
                error => console.error('obterChatTecnico', error)
              );
            }, 1000);
          }

          if (result && result.id && result.fechar) {
            this.router.navigate(["/tickets/details/", result.id]);
          }
        }
      });
    }
  }

  iniciarAtendimento(chat): void {
    if (this.deveAguardarCarregamentoMensagensParaMeta(chat)) {
      Swal.fire({
        text: 'Aguarde o carregamento da conversa para iniciar o atendimento.',
        icon: 'info',
        confirmButtonText: 'Ok',
        position: 'top'
      });
      return;
    }

    this.chatAtivoId = chat?._id;
    const precisaTemplateMeta = this.precisaTemplateMetaParaIniciarAgFila(chat);

    if (chat?.possui_fila_atribuida && !precisaTemplateMeta) {
      this.executarInicioAtendimento(chat);
      return;
    }

    this.newSubs = this.chatService.obterOpcoesIniciarAtendimento(chat?._id).subscribe({
      next: (result) => {
        const filas = result?.filas || [];
        const filaPadraoId = result?.fila_padrao_id || null;

        if (!chat?.possui_fila_atribuida && !filas.length) {
          Swal.fire({
            text: 'Não foi possível iniciar o atendimento, pois o operador não possui fila ativa vinculada a este canal.',
            icon: 'info',
            confirmButtonText: 'Ok',
            position: 'top'
          });
          return;
        }

        if (precisaTemplateMeta && !result?.integracao?.id) {
          Swal.fire({
            title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_INTEGRACAO'),
            icon: 'info',
            confirmButtonText: 'Ok',
            position: 'top'
          });
          return;
        }

        if (!precisaTemplateMeta && !chat?.possui_fila_atribuida && filas.length === 1) {
          this.executarInicioAtendimento(chat, { fila_atendimento_id: filaPadraoId || filas[0].id });
          return;
        }

        const modalRef = this.modalService.open(ModalIniciarAtendimentoChatComponent, {
          backdrop: 'static',
          windowClass: 'modal-custom-milvus start-service-history-modal',
          keyboard: false,
          size: 'lg',
          scrollable: false,
        });

        modalRef.componentInstance.chat = chat;
        modalRef.componentInstance.filas = filas;
        modalRef.componentInstance.integracao = result?.integracao || null;
        modalRef.componentInstance.nomeEmpresa = this.nomeEmpresa;
        modalRef.componentInstance.operador = this.operador;
        modalRef.componentInstance.mostrarTemplateMeta = precisaTemplateMeta;
        modalRef.componentInstance.filaInicialId = filaPadraoId;

        modalRef.result.then((modalResult) => {
          if (modalResult) {
            this.executarInicioAtendimento(chat, {
              fila_atendimento_id: modalResult.fila_atendimento_id
            }, modalResult.template);
          }
        });
      },
      error: (error) => {
        console.error('obterOpcoesIniciarAtendimento', error);
        const mensagemErro = error?.error_msg || error;
        if (mensagemErro) {
          Swal.fire({
            text: mensagemErro,
            icon: 'info',
            confirmButtonText: 'Ok',
            position: 'top'
          });
        }
      }
    });
  }

  private precisaTemplateMetaParaIniciarAgFila(chat): boolean {
    return !chat?.possui_fila_atribuida && chat?.whatsapp_oficial && this.ultimaMensagemClienteExpirouJanelaMeta();
  }

  deveAguardarCarregamentoMensagensParaMeta(chat): boolean {
    return !chat?.possui_fila_atribuida && chat?.whatsapp_oficial && this.trocandoChat && this.chatAtivoId === chat?._id;
  }

  private ultimaMensagemClienteExpirouJanelaMeta(): boolean {
    const mensagensCliente = Array.isArray(this.mensagensChat)
      ? this.mensagensChat.filter(mensagem => mensagem.enviado_por === 'cliente')
      : [];

    if (!mensagensCliente.length) {
      return true;
    }

    const ultimaMensagem = mensagensCliente[mensagensCliente.length - 1];
    const agora: any = new Date();
    const dataUltimaMensagem: any = new Date(ultimaMensagem.data_mensagem);
    const diff = new moment.duration(agora - dataUltimaMensagem);
    return Math.floor(diff.asSeconds()) >= 86400;
  }

  private executarInicioAtendimento(chat, payload: any = {}, template?: any): void {
    this.newSubs = this.chatService.iniciarAtendimento(chat?._id, payload).subscribe({
      next: () => {
        this.toastr.show(
          this.translate.instant("ATENDIMENTO_INICIADO"),
          "",
          environment.toastrConfig("success")
        );
        this.chatSelecionado.status = "Em Atendimento";
        this.statusSelecionado = 2;
        this.loadChats();
        this.obterChatTecnico(this.chatAtivoId, () => {
          if (template?.template_name && template?.template_content) {
            setTimeout(() => {
              this.enviarMsg(true, template);
            }, 150);
          }
        });
      },
      error: (error) => {
        console.error('iniciarAtendimento', error);
        const mensagemErro = error?.error_msg || error;
        if (mensagemErro) {
          Swal.fire({
            text: mensagemErro,
            icon: 'info',
            confirmButtonText: 'Ok',
            position: 'top'
          });
        }
      }
    });
  }

  obterChatTecnico(chat_id, onComplete?: () => void) {
    this.newSubs = this.chatService.obterChatTecnico(chat_id).subscribe(
      (result) => {
        if (result) {
          this.chatSelecionado = result.chat;
          this.abrirChat(result.chat, true);
          if (onComplete) {
            onComplete();
          }
        }
      },
      error => console.error('obterChatTecnico', error)
    );
  }

  clickAnexo() {
    let fileInput = document.getElementById("fileInputAnexoChat-" + this.chatSelecionado._id);
    if (fileInput) {
      fileInput.click();
    }
  }

  async changeFile(file: any) {
    const chatSelecionado = this.chatSelecionado;

    if (file.length > 0 && file.length < 6) {
      for (let i = 0; i < file.length; i++) {
        var mime = require('mime');
        var tipo = mime.getType(file[i].name);

        if (tipo !== null) {
          tipo = tipo.split("/");
        } else {
          let ext = file[i].name.split('.');
          tipo = ext;
        }

        tipo[1] = environment.convertUploadType(tipo[1]);

        var suportado = this.uploadFileType.indexOf(tipo[1]);
        if (file[i] && file[i].size <= this.uploadFileSize && suportado !== -1) {
          this.chatService.adicionarAnexo(file[i], chatSelecionado._id).subscribe(
            async (res) => {
              if (chatSelecionado && chatSelecionado?._id === this.websocketService.chatTela) {
                this.autoMsg(res, "anexo", chatSelecionado);
              } else {
                this.enviaAnexoOutroChat(chatSelecionado, res);
              }
            },
            error => console.error('changeFile', error)
          );
        } else {
          this.toastr.show(
            this.translate.instant("ARQUIVO_NAO_SUPORTADO_OU_EXCEDEU_LIMITE"),
            "",
            environment.toastrConfig("warning")
          );
        }
      }
    } else if (file.length >= 6) {
      this.toastr.show(this.translate.instant('QNT_ANEXOS_EXCEDIDO'), '', environment.toastrConfig('warning'));
    }
  }

  async autoMsg(msg: any, type: any, chatSelecionado?: any) {
    console.log('autoMsg', this.respostaSelecionada);

    if (chatSelecionado && chatSelecionado?._id !== this.websocketService.chatTela) {
      this.toastr.show("CHAT_SELECIONADO_INVALIDO", "", environment.toastrConfig("warning"));
      return;
    }

    if (chatSelecionado?._id !== this.chatSelecionado?._id) {
      this.toastr.show("CHAT_SELECIONADO_INVALIDO", "", environment.toastrConfig("warning"));
      return;
    }

    if (this.chatSelecionado?._id !== this.websocketService.chatTela) {
      this.toastr.show("CHAT_SELECIONADO_INVALIDO", "", environment.toastrConfig("warning"));
      return;
    }

    let anexo_id = null;

    if (msg.link) {
      anexo_id = msg.message_id;
      msg = msg.link;
    }

    let resposta_message_id = null;

    if (this.respostaSelecionada && this.respostaSelecionada.whatsapp_id) {
      resposta_message_id = this.respostaSelecionada.whatsapp_id;
    } else if (this.respostaSelecionada && this.respostaSelecionada.message_id) {
      resposta_message_id = this.respostaSelecionada.message_id;
    }

    var _msg = {
      user: this.tokenData?.nome,
      chat_id: this.chatSelecionado._id,
      enviado_por: "tecnico",
      tipo: type,
      img: this.tokenData?.foto,
      resposta_message_id,
      msg: msg,
      message_id: this.respostaSelecionada ? this.respostaSelecionada.message_id : null,
      token_widget: this.chatSelecionado.widget.token_widget,
      nome: this.tokenData?.nome,
      data: new Date(),
      message: msg,
      origem: 'gestor',
      body: msg,
    };

    this.chatService.enviarMsg(_msg)
      .subscribe({
        next: (results) => {
          if (results?.ultima_mensagem && results?.ultima_mensagem?.chat_id === this.chatSelecionado?._id) {
            this.mudouStatusMsg(results?.ultima_mensagem);
            this.formatBodyMsg(results?.ultima_mensagem, 'interno');
            if (this.mensagensChat.length) {
              this.mensagensChat.push(results?.ultima_mensagem);
            } else {
              this.mensagensChat = [results?.ultima_mensagem];
            }
            this.chatAtivoId = this.chatSelecionado._id;
            this.setFirstMsgList(this.chatSelecionado._id, _msg.msg);
            this.mensagem = "";
            this.respostaSelecionada = null;
            this.locked = true;
            this.myScrollContainer.nativeElement.scrollTop =
              this.myScrollContainer.nativeElement.scrollHeight + 20;
            this.atualizaDataInteracao(
              this.tokenService.convertDateTimezoneToView(new Date())
            );
          }
        }, error: (error) => {
          if (this.tratarErroEnvioChatFinalizado(error, _msg.chat_id)) {
            return;
          }
          console.error('autoMsg', error);
        }
      });

    // Comentado caso necessário rollback
    // this.websocketService.addMsgChat(_msg, (mesagemAtualizada) => {
    //   console.log('Mensagem retornada:', mesagemAtualizada);
    //   this.mudouStatusMsg(mesagemAtualizada);
    //   this.formatBodyMsg(mesagemAtualizada, 'interno');
    //   if (this.mensagensChat.length) {
    //     this.mensagensChat.push(mesagemAtualizada);
    //   } else {
    //     this.mensagensChat = [mesagemAtualizada];
    //   }
    //   this.chatAtivoId = this.chatSelecionado?._id;
    //   this.setFirstMsgList(this.chatSelecionado?._id, this.mensagem);
    //   this.mensagem = "";
    //   this.locked = true;
    //   this.myScrollContainer.nativeElement.scrollTop =
    //     this.myScrollContainer.nativeElement.scrollHeight + 20;
    //   this.atualizaDataInteracao(
    //     this.tokenService.convertDateTimezoneToView(new Date())
    //   );
    // });

    // await this.websocketService.addMsgChat(_msg, null);

    // this.mensagensChat.push(_msg);
    // this.formatBodyMsg(_msg, 'interno');

    // this.chatAtivoId = this.chatSelecionado._id;
    // this.mensagem = "";
    // this.locked = true;
    // this.setFirstMsgList(this.chatSelecionado._id, msg);
    // this.scrollToBottom();
    // this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight + 20;
  }

  changeStatus(idStatus: any) {
    this.statusChange$.next(idStatus)
  }

  changeGrupo() {
    this.loadingChats = true;
    this.gruposSelecionado = true;
    this.statusSelecionado = null;
    this.listaChats = [];
    this.paginaChats = 1;
    this.offSetChats = this.buscaGuardaQntChatSalvo(true);
    this.searchText = '';
    this.totalRegistrosChats = undefined;

    if (this.tokenData && this.tokenData.id) {
      this.loadChats();
    }
  }

  reenviarMsg() {

    if (!this.podeEnviarMensagemNoChatAtual()) {
      return;
    }

    const pendenciaComErro = (this.envioLocalPendente || []).find(item =>
      item?.chatId === this.chatSelecionado?._id && item?.status === 'error'
    );

    if (pendenciaComErro) {
      const indiceMensagem = this.buscarIndiceMensagemNaListagem({}, pendenciaComErro.clientTempId);
      const mensagemPendente = indiceMensagem !== -1 ? this.mensagensChat[indiceMensagem] : null;
      if (mensagemPendente) {
        this.reenviarMensagemPendente(mensagemPendente);
        return;
      }
    }

    if (this.reenviarMensagem !== "" && this.reenviarMensagem !== undefined) {
      var _msg = {
        user: this.tokenData?.nome,
        chat_id: this.chatSelecionado._id,
        enviado_por: "tecnico",
        tipo: "texto",
        img: this.tokenData?.foto,
        msg: this.reenviarMensagem,
        token_widget: this.chatSelecionado.widget.token_widget,
        nome: this.tokenData?.nome,
        data: new Date(),
        origem: 'gestor',
        message: this.reenviarMensagem,
        body: this.reenviarMensagem,
      };

      this.chatService.enviarMsg(_msg)
        .subscribe({
          next: (results) => {
            if (results?.ultima_mensagem) {
              this.mudouStatusMsg(results?.ultima_mensagem);
              this.formatBodyMsg(results?.ultima_mensagem, 'interno');
              if (this.mensagensChat.length) {
                this.mensagensChat.push(results?.ultima_mensagem);
              } else {
                this.mensagensChat = [results?.ultima_mensagem];
              }
              this.chatAtivoId = this.chatSelecionado._id;
              this.setFirstMsgList(this.chatSelecionado._id, this.mensagem);
              this.mensagem = "";
              this.respostaSelecionada = null;
              this.locked = true;
              this.myScrollContainer.nativeElement.scrollTop =
                this.myScrollContainer.nativeElement.scrollHeight + 20;
              this.atualizaDataInteracao(
                this.tokenService.convertDateTimezoneToView(new Date())
              );
            }
          }, error: (error) => console.error('reenviarMsg', error)
        });

      // Comentado caso necessário rollback
      // this.websocketService.addSocketMsgChat(_msg, this.chatSelecionadoSocket, null);
      // this.mensagensChat.push(_msg);
      // this.formatBodyMsg(_msg, 'interno');
      // this.chatAtivoId = this.chatSelecionado?._id;
      // this.mensagem = "";
      // this.locked = true;
      // this.setFirstMsgList(this.chatSelecionado?._id, this.reenviarMensagem);
      // this.scrollToBottom();
      // this.myScrollContainer.nativeElement.scrollTop =
      //   this.myScrollContainer.nativeElement.scrollHeight + 20;
    }
  }

  handleClickMensagemOrigem(msg: any, event: any): void {
    if (this.podeReenviarMensagemPendente(msg)) {
      event?.preventDefault?.();
      event?.stopPropagation?.();
      this.reenviarMensagemPendente(msg);
      return;
    }

    this.visualizarArquivo(msg, event);
  }

  private podeEnviarMensagemNoChatAtual(): boolean {
    return !(
      this.chatSelecionado?.status_id === STATUS_CHAT.FINALIZADO ||
      this.chatSelecionado?.status_id === STATUS_CHAT.AG_ATENDIMENTO ||
      this.chatSelecionado?.bloqueado === true ||
      this.conectado === false ||
      this.historico_chat ||
      this.apenas_historico
    );
  }

  private podeReenviarMensagemPendente(msg: any): boolean {
    const pendencia = this.buscarEnvioLocalPendentePorMensagem(msg);
    return this.podeEnviarMensagemNoChatAtual() && !!(pendencia?.status === 'error' && pendencia?.payload);
  }

  private reenviarMensagemPendente(msg: any): void {
    const pendencia = this.buscarEnvioLocalPendentePorMensagem(msg);
    if (!pendencia || pendencia.status !== 'error' || !pendencia.payload || !this.podeEnviarMensagemNoChatAtual()) {
      return;
    }

    if (this.bloquearEnvioDuplicadoTemporario(`retry|${pendencia.clientTempId}`)) {
      return;
    }

    const payload = {
      ...pendencia.payload,
      data: new Date()
    };

    this.atualizarEnvioLocalPendente(pendencia.clientTempId, {
      payload,
      createdAt: Date.now(),
      status: 'sending',
      errorMessage: null,
      ignoreAtualizacaoChat: true,
      ignoreBuscaConversa: true
    });

    const indiceMensagem = this.buscarIndiceMensagemNaListagem(msg, pendencia.clientTempId);
    if (indiceMensagem !== -1) {
      const mensagemAtualLista = this.mensagensChat[indiceMensagem];
      const mensagemAtualizada = {
        ...mensagemAtualLista,
        ...this.criarMensagemLocalListagem({
          ...payload,
          resposta_message: mensagemAtualLista?.resposta_message,
          resposta_enviado_por: mensagemAtualLista?.resposta_enviado_por
        }, pendencia.clientTempId),
        data_mensagem: new Date(),
        status_mensagem: 1,
        status_envio_id: 1,
        erro_envio: null,
        error_msg: null,
        error_msg_descricao: null,
        error_code: null,
        local_storage_pendente: false,
        formatedBody: null,
        formatedBodyResposta: null
      };

      this.formatBodyMsg(mensagemAtualizada, 'interno');
      this.mensagensChat[indiceMensagem] = mensagemAtualizada;
    }

    this.chatService.enviarMsg(payload)
      .subscribe({
        next: (results) => {
          if (results?.ultima_mensagem) {
            this.substituirMsgListagem(results?.ultima_mensagem, pendencia.clientTempId);
          }
        }, error: (error) => {
          if (this.tratarErroEnvioChatFinalizado(error, payload.chat_id, pendencia.clientTempId)) {
            return;
          }
          if (indiceMensagem !== -1) {
            this.marcarErroMsgListagem(this.mensagensChat[indiceMensagem], error);
          }
        }
      });
  }

  formatLinkOrText(array) {
    var _msg: string = "";
    array?.forEach((element) => {
      if (element.indexOf("http") !== -1) {
        _msg +=
          "<a target='_blank' href='" + element + "'>" + element + " </a>";
      } else {
        _msg += element + " ";
      }
    });
    return _msg.trimRight();
  }

  openHistorico(chat): void {
    const modalRef = this.modalService.open(ModalHistoricoListaChatsComponent, {
      backdrop: 'static',
      scrollable: false,
      windowClass: 'modal-custom-milvus',
      keyboard: true,
      size: 'grande'
    });

    modalRef.componentInstance.solicitantes_habilitados = this.solicitantes_habilitados;
    modalRef.componentInstance.chat_contato = chat.contato;
  }

  verificarExibicaoIconeHistoricoUsoBaseIa(chatId: string): void {
    this.isMostrarHistoricoUsoBaseIa = false;

    if (!chatId) {
      return;
    }

    this.newSubs = forkJoin({
      exibirIcone: this.chatService.mostrarIconeHistoricoUsoBaseIa(chatId),
      historicoUsoBaseIa: this.chatService.listarHistoricoUsoBaseIa(chatId)
    }).subscribe({
      next: ({ exibirIcone, historicoUsoBaseIa }) => {
        const possuiHistoricoUsoBaseIa = (historicoUsoBaseIa?.lista || []).length > 0;
        this.isMostrarHistoricoUsoBaseIa = exibirIcone?.is_mostrar === true && possuiHistoricoUsoBaseIa;
      },
      error: (error) => {
        this.isMostrarHistoricoUsoBaseIa = false;
        console.error('verificarExibicaoIconeHistoricoUsoBaseIa', error);
      }
    });
  }

  openHistoricoUsoBaseIa(chat): void {
    const modalRef = this.modalService.open(ChatHistoricoUsoBaseIaComponent, {
      scrollable: false,
      windowClass: 'modal-custom-milvus',
      size: 'historico-uso-base-ia',
      keyboard: false,
      backdrop: 'static'
    });
    modalRef.componentInstance.chat = chat;
  }

  openHistoricoUnificado(chat): void {
    const modalRef = this.modalService.open(ChatHistoricoUnificadoComponent,
      {
        scrollable: false,
        windowClass: 'modal-custom-milvus',
        size: 'medio',
        keyboard: false,
        backdrop: 'static'
      });

    chat.selecionado = true;

    modalRef.componentInstance.historico_chat = chat;
    modalRef.componentInstance.provider_id = this.provider_id;
    // modalRef.componentInstance.apenas_historico = true;
    // modalRef.componentInstance.historico_unificado = true;
  }

  openTicket(ticket): void {
    var url = location.origin + "/tickets/details/" + ticket.id;
    window.open(url, "_blank");
  }

  iniciaConversaWhatsApp(contato): void {
    if (this.provider_id !== 4) {
      this.newSubs = this.chatService
        .iniciarConversaWhatsappChamado(contato)
        .subscribe(
          (results) => {
            if (results) {
              this.chatAtivoId = results?.chat?._id;
              this.loadChats();
              this.abrirChat(results?.chat);
            }
          },
          error => console.error('iniciaConversaWhatsApp', error)
        );
    } else {
      let _payload = {
        from: contato.from,
        numero_destino: contato.numero_destino,
        template_name: contato.template_name,
        language: contato.language,
        contato_id: contato.id || contato.contato_id,
        chamado_id: contato.chamado_id
      };

      this.newSubs = this.whatsappService.wppOfficialStartChat(contato.integracao_id, contato)
        .subscribe({
          next: (results) => {
            if (results) {
              this.chatAtivoId = results?.chat?._id;
              this.loadChats();
              this.abrirChat(results?.chat);
            }
          },
          error: (error) => console.error('iniciaConversaWhatsApp', error)
        });
    }
  }

  iniciaConversaWhatsAppUnificado(contato): void {
    let _payload = {
      from: contato.from,
      numero_destino: contato.numero_destino,
      template_name: contato.template_name,
      template_content: contato.template_content,
      language: contato.language || 'pt_BR',
      contato_id: contato.id || contato.contato_id,
      chamado_id: contato.chamado_id,
      chamado_codigo: contato.chamado_codigo
    };

    this.newSubs = this.whatsappService
      .wppIniciarConversaUnificado({ ...contato, _payload })
      .subscribe(
        (results) => {
          if (results) {
            this.chatAtivoId = results?.chat?._id;
            this.loadChats();
            this.abrirChat(results?.chat);
          }
        },
        error => console.error('iniciaConversaWhatsAppUnificado', error)
      );
  }

  notificarChatFinalizado(chatData: any): void {
    let chat_id = chatData.chat_id;
    let locate = this.listaChats.findIndex((x) => {
      return x?._id === chat_id;
    });
    if (locate !== -1) {
      this.listaChats[locate].status = "Finalizado";
      this.listaChats[locate].status_id = 3;
    }
  }

  marcarLido(chatSelecionado) {
    let chat = this.listaChats.find((el) => el?._id === chatSelecionado?._id);
    if (chat && chat.possui_mensagens_nao_lidas) {
      this.chatService.mensagemChatLida(chat?._id).subscribe((result) => {
        //removendo status de não lido
        this.listaChats?.forEach((element) => {
          if (element?._id === chat?._id) {
            element.possui_mensagens_nao_lidas = false;
          }
        });
      }, error => console.error('marcarLido', error));
    }
  }

  onEnterKeyPress(event: any) {
    event.preventDefault();
  }

  autoGrow(key, chatBox, chatMsgs, fromButton?) {
    const respostaBox = document.getElementById('respostaBox');

    setTimeout(() => {
      if (fromButton) {
        chatBox.style.height = "auto";
        if (chatMsgs) {
          chatMsgs.style.bottom = "193px";
        }
        if (respostaBox) {
          respostaBox.style.bottom = "70px";
        }
      } else {
        if (
          key.key === "Enter" &&
          key.shiftKey === false &&
          key.altKey === false
        ) {
          if (this.mensagem == "\n") {
            return (this.mensagem = "");
          }

          if (!this.podeEnviarMensagemNoChatAtual()) {
            if (
              this.chatSelecionado?.status_id === STATUS_CHAT.FINALIZADO ||
              this.chatSelecionado?.bloqueado
            ) {
              this.toastr.show(
                this.translate.instant('CHAT_FINALIZADO_NAO_ENVIAR'),
                '',
                environment.toastrConfig('warning')
              );
            }
            return;
          }

          this.enviarMsg();
          chatBox.style.height = "auto";
          if (chatMsgs) {
            chatMsgs.style.bottom = "193px";
          }
          if (respostaBox) {
            respostaBox.style.bottom = "70px";
          }
        } else {
          chatBox.style.height = "auto";
          chatBox.style.height = chatBox.scrollHeight + "px";

          if (chatBox.scrollHeight > 50) {
            if (chatMsgs) {
              chatMsgs.style.bottom = 193 + (chatBox.clientHeight - 50) + "px";
            }
            if (respostaBox) {
              respostaBox.style.bottom = 70 + (chatBox.clientHeight - 50) + "px";
            }
          } else {
            if (chatMsgs) {
              chatMsgs.style.bottom = "193px";
            }
            if (respostaBox) {
              respostaBox.style.bottom = "70px";
            }
          }
        }
      }
    }, 10);
  }

  capturaImagemClipboard(data): any {
    if (data && data.length) {
      if (data[0].type.indexOf('image') === 0) {
        return data[0]
      } else if (data[0].type.indexOf('html') === 5) {
        return data[1];
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  verificaImagemOnPaste(e): void {
    const items = (e.clipboardData || e.originalEvent.clipboardData).items;
    let blob = null;
    const item = this.capturaImagemClipboard(items);
    if (item) {
      blob = item.getAsFile();
      if (blob) {
        const chatDaColagem = this.chatSelecionado;
        const reader = new FileReader();
        reader.onload = () => {
          const modalRef = this.modalService.open(VisualizadorArquivosComponent, {
            scrollable: false,
            windowClass: 'modal-custom-arquivos',
            size: 'grande',
            keyboard: false,
          });

          modalRef.componentInstance.fileUrl = reader.result as string;
          modalRef.componentInstance.visualizar_enviar = true;
          modalRef.result.then(result => {
            if (result) {
              if (this.chatSelecionado?._id !== chatDaColagem?._id) {
                this.toastr.show("CHAT_SELECIONADO_INVALIDO", "", environment.toastrConfig("warning"));
                return;
              }
              this.changeFile([blob]);
            }
          });
        };
        reader.onerror = () => {
          this.toastr.show(this.translate.instant('UPLOAD_FAILED'), '', environment.toastrConfig('warning'));
        };
        reader.readAsDataURL(blob);
      } else {
        this.toastr.show(this.translate.instant('UPLOAD_FAILED'), '', environment.toastrConfig('warning'));
      }
    }
  }

  geraClasseFila(fila): string {
    if (fila && fila.id) {
      const indexFila = this.arrayFilasExistentes.indexOf(fila.id);
      if (indexFila !== -1) {
        return "fila-" + indexFila;
      } else {
        this.arrayFilasExistentes.push(fila.id);
        return "fila-" + (this.arrayFilasExistentes.length - 1);
      }
    }
  }

  replaceAt(string, index, replacement) {
    let firstPart = string.substr(0, index);
    let lastPart = string.substr(index + 1);
    let newString = firstPart + replacement + lastPart;
    return newString;
  }

  private splitTrailingUrlSuffix(url: string, fullText?: string, offset?: number): { url: string, suffix: string } {
    let sanitizedUrl = url;
    let suffix = '';

    while (sanitizedUrl.length > 0) {
      const lastChar = sanitizedUrl[sanitizedUrl.length - 1];

      if (['.', ',', ';', ':', '!', '?'].includes(lastChar)) {
        suffix = lastChar + suffix;
        sanitizedUrl = sanitizedUrl.slice(0, -1);
        continue;
      }

      if (lastChar === ')') {
        const openCount = (sanitizedUrl.match(/\(/g) || []).length;
        const closeCount = (sanitizedUrl.match(/\)/g) || []).length;

        if (closeCount > openCount) {
          suffix = lastChar + suffix;
          sanitizedUrl = sanitizedUrl.slice(0, -1);
          continue;
        }
      }

      if (['*', '_', '~', '`'].includes(lastChar)) {
        const previousChar = typeof offset === 'number' && offset > 0 && fullText
          ? fullText[offset - 1]
          : '';

        if (previousChar === lastChar) {
          suffix = lastChar + suffix;
          sanitizedUrl = sanitizedUrl.slice(0, -1);
          continue;
        }
      }

      break;
    }

    return { url: sanitizedUrl, suffix };
  }

  private preserveUrls(msgBody: string): { formattedBody: string, urls: string[] } {
    const urls: string[] = [];
    const formattedBody = msgBody.replace(/https?:\/\/[^\s<]+/gi, (matchedUrl, offset, fullText) => {
      const { url, suffix } = this.splitTrailingUrlSuffix(matchedUrl, fullText, offset);
      const token = `MILVUSURLTOKEN${urls.length}ENDTOKEN`;
      urls.push(url);
      return token + suffix;
    });

    return { formattedBody, urls };
  }

  private restorePreservedUrls(msgBody: string, urls: string[]): string {
    return msgBody.replace(/MILVUSURLTOKEN(\d+)ENDTOKEN/g, (match, index) => urls[Number(index)] || match);
  }

  applyWppFormat(msgBody): string {
    if (!msgBody) {
      return msgBody;
    }

    const { formattedBody, urls } = this.preserveUrls(msgBody);
    msgBody = formattedBody;

    if (msgBody[0] === '>') {
      let msgFormatted = msgBody.substring(1);
      msgBody = '<cite style="border-left: 3px solid gray; padding-left: 4px; display: block; opacity: 0.8;">' + msgFormatted + '</cite>';
    } else if (msgBody[0] === '-' && msgBody[1] === ' ') {
      msgBody = '<ul>' + msgBody.replaceAll('- ', '• ') + '</ul>';
    } else if (msgBody[0] === '*' && msgBody[1] === ' ') {
      msgBody = '<ul>' + msgBody.replaceAll('* ', '• ') + '</ul>';
    } else if (msgBody[0] === '1' && msgBody[1] === '.') {
      msgBody = '<ul>' + msgBody + '</ul>';
    }

    msgBody = msgBody.replace('```', '<samp>');
    msgBody = msgBody.replace('```', '</samp>');

    let formatacoes_possiveis = {
      negrito: null,
      italico: null,
      codigo: null,
      rasurado: null
    };

    for (let i = 0; i < msgBody.length; i++) {
      switch (msgBody[i]) {
        case '*':
          if (formatacoes_possiveis.negrito !== null) {
            msgBody = this.replaceAt(msgBody, formatacoes_possiveis.negrito, '<b>');
            msgBody = this.replaceAt(msgBody, (i + 2), '</b>');
            formatacoes_possiveis.negrito = null;
          } else {
            formatacoes_possiveis.negrito = i;
          }
          break;
        case '_':
          if (formatacoes_possiveis.italico !== null) {
            msgBody = this.replaceAt(msgBody, formatacoes_possiveis.italico, '<i>');
            msgBody = this.replaceAt(msgBody, (i + 2), '</i>');
            formatacoes_possiveis.italico = null;
          } else {
            formatacoes_possiveis.italico = i;
          }
          break;
        case '~':
          if (formatacoes_possiveis.rasurado !== null) {
            msgBody = this.replaceAt(msgBody, formatacoes_possiveis.rasurado, '<del>');
            msgBody = this.replaceAt(msgBody, (i + 4), '</del>');
            formatacoes_possiveis.rasurado = null;
          } else {
            formatacoes_possiveis.rasurado = i;
          }
          break;
        case '`':
          if (msgBody[i - 1] !== '`' && msgBody[i + 1] !== '`') {
            if (formatacoes_possiveis.codigo !== null) {
              msgBody = this.replaceAt(msgBody, formatacoes_possiveis.codigo, '<code>');
              msgBody = this.replaceAt(msgBody, (i + 5), '</code>');
              formatacoes_possiveis.codigo = null;
            } else {
              formatacoes_possiveis.codigo = i;
            }
          }
          break;
      }
    };

    return this.restorePreservedUrls(msgBody, urls);
  }

  applyWppFormatLegend(msgBody): string {
    return this.applyWppFormat(msgBody);
  }

  private mensagemTransferidaPossuiConteudoHtml(mensagem: any): boolean {
    if (mensagem?.is_mensagem_email || mensagem?.body_format === 'html' || mensagem?.email_html_corpo) {
      return true;
    }

    const conteudoMensagem = `${mensagem?.body || ''}${mensagem?.msg || ''}`;
    return /<(div|table|p|span|br|img|a|html|body)[\s>/]/i.test(conteudoMensagem);
  }

  private prepararMensagemTransferida(mensagemTransferida: any): void {
    if (mensagemTransferida.enviado_por === 'robo') {
      mensagemTransferida.autor = mensagemTransferida.autor || {};
      mensagemTransferida.autor.nome = this.translate.instant('CHATBOT') || 'Chatbot';
    }

    if (this.mensagemTransferidaPossuiConteudoHtml(mensagemTransferida)) {
      mensagemTransferida.is_mensagem_email = true;
      mensagemTransferida.body_format = mensagemTransferida.body_format || 'html';

      if (!mensagemTransferida.email_html_corpo) {
        mensagemTransferida.email_html_corpo = mensagemTransferida.body || mensagemTransferida.msg || '';
      }
    } else if (mensagemTransferida.email_cabecalho || mensagemTransferida.anexos_email?.length) {
      mensagemTransferida.is_mensagem_email = true;
    }

    const origemFormatacao = (mensagemTransferida.enviado_por === 'robo' || mensagemTransferida.enviado_por === 'tecnico' || mensagemTransferida.is_tranferencia) ? 'interno' : 'externo';
    this.formatBodyMsg(mensagemTransferida, origemFormatacao);
  }

  private elementoCitacaoGmailEhRaiz(elementoCitacaoGmail: Element, corpoDocumento: Element): boolean {
    let elementoPai = elementoCitacaoGmail.parentElement;

    while (elementoPai && elementoPai !== corpoDocumento) {
      if (
        elementoPai.classList.contains('gmail_quote_container') ||
        elementoPai.classList.contains('gmail_quote')
      ) {
        return false;
      }

      elementoPai = elementoPai.parentElement;
    }

    return true;
  }

  private desembrulharCitacoesGmailInternasEmailChat(documentoHtml: Document): void {
    const citacoesGmailInternas = Array.from(
      documentoHtml.body.querySelectorAll('blockquote div.gmail_quote, blockquote div.gmail_quote_container')
    );

    citacoesGmailInternas.forEach((elementoCitacaoGmailInterna) => {
      while (elementoCitacaoGmailInterna.firstChild) {
        elementoCitacaoGmailInterna.parentNode?.insertBefore(
          elementoCitacaoGmailInterna.firstChild,
          elementoCitacaoGmailInterna
        );
      }

      elementoCitacaoGmailInterna.remove();
    });
  }

  private normalizarHtmlCitacaoMensagemEmailChat(htmlCorpoEmail: string): string {
    if (!htmlCorpoEmail?.trim()) {
      return htmlCorpoEmail;
    }

    const documentoHtml = new DOMParser().parseFromString(htmlCorpoEmail, 'text/html');
    const elementosCitacaoGmailRaiz = Array.from(
      documentoHtml.body.querySelectorAll('div.gmail_quote_container, div.gmail_quote')
    )
      .filter((elementoCitacaoGmail) =>
        this.elementoCitacaoGmailEhRaiz(elementoCitacaoGmail, documentoHtml.body)
      )
      .reverse();

    elementosCitacaoGmailRaiz.forEach((elementoCitacaoGmail) => {
      const blockquoteCitacao = documentoHtml.createElement('blockquote');

      while (elementoCitacaoGmail.firstChild) {
        blockquoteCitacao.appendChild(elementoCitacaoGmail.firstChild);
      }

      elementoCitacaoGmail.replaceWith(blockquoteCitacao);
    });

    this.desembrulharCitacoesGmailInternasEmailChat(documentoHtml);

    return documentoHtml.body.innerHTML;
  }

  formatBodyMsg(msg, source, newMsg?): void {
    let theme = "msg-resposta";
    let themePor = '';

    if (localStorage.getItem("theme")) {
      theme = localStorage.getItem("theme") == "light" ? "msg-resposta" : "msg-resposta-dark";
    }

    msg.theme = theme;

    if (msg.tipo == 'contato') {
      msg.contato = JSON.parse(msg.body || msg.msg);
    }

    if (msg.is_mensagem_email) {
      if (msg.email_html_corpo) {
        msg.email_html_corpo = this.normalizarHtmlCitacaoMensagemEmailChat(msg.email_html_corpo);
        msg.body = msg.email_html_corpo;
      }
      if (!msg.withoutTime) {
        msg.withoutTime = true;
        if (msg.enviado_por === 'cliente') {
          msg.email_html_corpo +=
            '<div class="text-right"><span class="msg-time" style="font-size: 10px;margin-top: 6px;">' +
            moment(msg.data_mensagem ? msg.data_mensagem : msg.data).local().format('DD/MM/YYYY HH:mm:ss') +
            "</span>";
        } else {
          msg.email_html_corpo +=
            '<div class="text-left"><span class="msg-time" style="font-size: 10px;margin-top: 6px;">' +
            moment(msg.data_mensagem ? msg.data_mensagem : msg.data).local().format('DD/MM/YYYY HH:mm:ss') +
            "</span>";
        }
      }
    } else if (this.chatSelecionado.is_whatsapp && msg.tipo !== 'anexo') {
      let msg_content = this.applyWppFormat(msg.body || msg.msg);
      if (msg.body) {
        msg.body = msg_content;
      } else if (msg.msg) {
        msg.msg = msg_content;
      }
    }

    const conteudoMensagemOriginal = msg.body || msg.msg || '';
    let conteudoMensagemRenderizado = conteudoMensagemOriginal;
    let messageParsed = conteudoMensagemRenderizado;
    messageParsed = (messageParsed && messageParsed !== '') ? messageParsed.split(".") : messageParsed;

    let messageParsed_resposta = msg.resposta_message || '';
    messageParsed_resposta = (messageParsed_resposta && messageParsed_resposta !== '') ? messageParsed_resposta.split(".") : messageParsed_resposta;

    let nome_usuario = this.chatSelecionado?.contato?.descricao || this.chatSelecionado?.numero_contato;

    let enviado_por_resposta = msg.resposta_enviado_por == 'cliente' ? nome_usuario : 'Você';

    msg.enviado_por_resposta = enviado_por_resposta;

    let enviado_por = msg.enviado_por == 'cliente' ? nome_usuario : ' Você';

    msg.enviado_por_mensagem = enviado_por;

    msg.id = msg.id || msg.message_id || msg.whatsapp_id;

    let horario = "";
    let contato_resposta = "";

    let mensagemErro = msg.erro_envio ?
      `<div class="d-flex align-items-center gap-2">
        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.70312 2.04297C9.76562 1.9375 9.87891 1.875 10 1.875C10.1211 1.875 10.2344 1.9375 10.2969 2.04297L18.043 14.7656C18.0977 14.8555 18.125 14.957 18.125 15.0586C18.125 15.3711 17.8711 15.625 17.5586 15.625H2.44141C2.12891 15.625 1.875 15.3711 1.875 15.0586C1.875 14.9531 1.90234 14.8516 1.95703 14.7656L9.70312 2.04297ZM8.10156 1.06641L0.355469 13.7891C0.121094 14.1719 0 14.6094 0 15.0586C0 16.4062 1.09375 17.5 2.44141 17.5H17.5586C18.9062 17.5 20 16.4062 20 15.0586C20 14.6094 19.875 14.1719 19.6445 13.7891L11.8984 1.06641C11.4961 0.40625 10.7773 0 10 0C9.22266 0 8.50391 0.40625 8.10156 1.06641ZM11.25 13.125C11.25 12.7935 11.1183 12.4755 10.8839 12.2411C10.6495 12.0067 10.3315 11.875 10 11.875C9.66848 11.875 9.35054 12.0067 9.11612 12.2411C8.8817 12.4755 8.75 12.7935 8.75 13.125C8.75 13.4565 8.8817 13.7745 9.11612 14.0089C9.35054 14.2433 9.66848 14.375 10 14.375C10.3315 14.375 10.6495 14.2433 10.8839 14.0089C11.1183 13.7745 11.25 13.4565 11.25 13.125ZM10.9375 5.9375C10.9375 5.41797 10.5195 5 10 5C9.48047 5 9.0625 5.41797 9.0625 5.9375V9.6875C9.0625 10.207 9.48047 10.625 10 10.625C10.5195 10.625 10.9375 10.207 10.9375 9.6875V5.9375Z" fill="#FF0000"/>
        </svg>
        <div>Erro: ${msg.erro_envio}</div>
      </div></br>
      `
      : "";

    if (mensagemErro) {
      conteudoMensagemRenderizado = `${mensagemErro}${conteudoMensagemOriginal}`;
      messageParsed = (conteudoMensagemRenderizado && conteudoMensagemRenderizado !== '')
        ? conteudoMensagemRenderizado.split(".")
        : conteudoMensagemRenderizado;
    }

    if (msg.msg_legenda) {
      msg.msg_legenda = this.applyWppFormatLegend(msg.msg_legenda);
    }

    if (source === 'interno') {
      horario +=
        '<div class="text-left"><span class="msg-time" style="font-size: 10px;margin-top: 6px;">' +
        moment(msg.data_mensagem ? msg.data_mensagem : msg.data).local().format('DD/MM/YYYY HH:mm:ss') +
        "</span>";

      if (!msg.is_mensagem_email) {
        horario += this.setSendAndRead(msg);
      }

    } else {
      let formatedHour;
      if ((msg.tipo !== 'anexo' && !msg.msg_legenda) || (msg.tipo === 'anexo' && !msg.msg_legenda)) {
        const dataMensagem = moment(
          msg.data_mensagem ? msg.data_mensagem : msg.data,
          [moment.ISO_8601, 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD'],
          true
        );
        formatedHour = this.tokenService.convertDateTimezoneToView(dataMensagem.toDate());
        horario += '<div class=" text-right"><span class="msg-time" style="font-size: 10px;margin-top: 6px;">' +
          formatedHour +
          "</span>";
      }

      if (msg.resposta_enviado_por == 'cliente') {
        themePor = "msg-enviado-por-cliente";

        contato_resposta += '<div class="text-left"><span style="margin-top: 6px; color:rgb(53, 178, 124)">' +
          enviado_por +
          "</span><br/>";
      } else {
        themePor = "msg-enviado-por-tecnico";

        contato_resposta += '<div class="text-left"><span style="margin-top: 6px; color:rgb(110, 108, 222)">' +
          enviado_por +
          "</span><br/>";
      }

    }

    if (msg.resposta_enviado_por == 'cliente') {
      themePor = "msg-enviado-por-cliente";
    } else {
      themePor = "msg-enviado-por-tecnico";
    }

    msg.themePor = themePor;

    if (msg.status_mensagem === 4 && msg.error_msg) {
      const horarioSimples = moment(msg.data_mensagem ? msg.data_mensagem : msg.data).format('DD/MM/YYYY HH:mm:ss');

      const mensagemTexto = conteudoMensagemOriginal || '';

      const mensagemSegura = mensagemTexto.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const possuiCodigoErro = msg.error_code !== null && msg.error_code !== undefined && msg.error_code !== '';
      const tituloErro = possuiCodigoErro
        ? `Erro: ${msg.error_code} - ${msg.error_msg}`
        : `Erro: ${msg.error_msg}`;

      const errorHtml = `<div class="error-message">
  <div class="error-header">
    <i class="fa-regular fa-triangle-exclamation"></i>
    <span>${tituloErro}</span>
  </div>
  <div class="msg-body">${mensagemSegura}</div>
  <div class="msg-time">${horarioSimples}</div>
</div>`;

      msg.formatedBody = this.sanitizer.sanitize(SecurityContext.HTML, errorHtml);

      if (msg.error_code === '131047' || msg.error_code === 131047) {
        if (newMsg === true) {
          setTimeout(() => {
            this.verificarEAbrirModalErro131047(msg);
          }, 500);
        }
      }

      return;
    }

    if (msg.tipo === 'contato') {
      msg.formatedBody = this.sanitizer.sanitize(SecurityContext.HTML, horario);
      msg.formatedBodyResposta = this.sanitizer.sanitize(SecurityContext.HTML, msg.resposta_message);
    } else {

      if (messageParsed.length > 1) {
        if (messageParsed_resposta.length > 1) {
          msg.formatedBody = this.sanitizer.sanitize(SecurityContext.HTML, `<div class='${theme} ${themePor}'>` + contato_resposta + this.setMediaMsgResposta(msg.resposta_message, messageParsed_resposta) + "</div></div><div>" + `<div id=${msg.id}>` + this.setMediaMsg(conteudoMensagemRenderizado, messageParsed, source, msg) + "</div>" + horario + "</div>");
          msg.formatedBodyResposta = this.sanitizer.sanitize(SecurityContext.HTML, this.setMediaMsgResposta(msg.resposta_message, messageParsed_resposta));
        } else {
          msg.formatedBody = this.sanitizer.sanitize(SecurityContext.HTML, `<div id=${msg.id}>` + this.setMediaMsg(conteudoMensagemRenderizado, messageParsed, source, msg) + "</div>" + horario);
          msg.formatedBodyResposta = this.sanitizer.sanitize(SecurityContext.HTML, msg.resposta_message);
        }
      } else {
        if (messageParsed_resposta.length > 1) {
          msg.formatedBody = this.sanitizer.sanitize(SecurityContext.HTML, `<div id=${msg.id}>` + conteudoMensagemRenderizado + "</div>" + horario + "</div>");
          msg.formatedBodyResposta = this.sanitizer.sanitize(SecurityContext.HTML, this.setMediaMsgResposta(msg.resposta_message, messageParsed_resposta));
        } else {
          msg.formatedBody = this.sanitizer.sanitize(SecurityContext.HTML, `<div id=${msg.id}>` + conteudoMensagemRenderizado + "</div>" + horario);
          msg.formatedBodyResposta = this.sanitizer.sanitize(SecurityContext.HTML, msg.resposta_message);
        }
      }
    }

    this.mensagensChat
      ?.forEach(
        mensagem => {
          if (mensagem.message_id === msg.message_id) {
            mensagem = { ...mensagem, ...msg };
          }
        }
      )
  }

  transcriptAudio(msg): string {
    const fullTranscription = msg.transcricao_audio || msg.resumo_audio || '';
    const collapsedTranscription = this.getCollapsedSeeMoreText(fullTranscription);
    const showSeeMoreButton = fullTranscription.length > this.seeMoreLength;
    let seeMoreHtml = '';
    let transcriptionIdAttribute = '';

    if (showSeeMoreButton) {
      const seeMoreData = this.generateUniqueIdSeeMore(collapsedTranscription, fullTranscription);
      transcriptionIdAttribute = ' id="' + seeMoreData.transcriptionId + '"';
      seeMoreHtml =
        '<hr style="margin: 3px 0px;">' +
        '<button id="' + seeMoreData.seeMoreId + '" class="see-more-transcription pl-2" style="display: inline-block; width: 100%; border: 0; background: transparent; color: #1b8755;">' + this.translate.instant('VER_MAIS') + '</button>';
    }

    let returnedHtml =
      '<div class="transcription-audio"><span><img class="pr-2" src="assets/img/general/icon_openai_milvus.png" width="50">' +
      this.translate.instant('TRANSCRICAO_AUDIO') + ':</span>' +
      '<span' + transcriptionIdAttribute + '>' + collapsedTranscription + '</span>' +
      seeMoreHtml +
      '</div>';
    return returnedHtml;
  }

  transcriptImage(msg): string {
    const fullTranscription = msg.transcricao_imagem || '';
    const collapsedTranscription = this.getCollapsedSeeMoreText(fullTranscription);
    const showSeeMoreButton = fullTranscription.length > this.seeMoreLength;
    let seeMoreHtml = '';
    let transcriptionIdAttribute = '';

    if (showSeeMoreButton) {
      const seeMoreData = this.generateUniqueIdSeeMore(collapsedTranscription, fullTranscription);
      transcriptionIdAttribute = ' id="' + seeMoreData.transcriptionId + '"';
      seeMoreHtml =
        '<hr style="margin: 3px 0px;">' +
        '<button id="' + seeMoreData.seeMoreId + '" class="see-more-transcription pl-2" style="display: inline-block; width: 100%; border: 0; background: transparent; color: #1b8755;">' + this.translate.instant('VER_MAIS') + '</button>';
    }

    let returnedHtml =
      '<div class="transcription-audio"><span><img class="pr-2" src="assets/img/general/icon_openai_milvus.png" width="50">' +
      this.translate.instant('TRANSCRICAO_IMAGEM') + ':</span>' +
      '<span' + transcriptionIdAttribute + '>' + collapsedTranscription + '</span>' +
      seeMoreHtml +
      '</div>';
    return returnedHtml;
  }

  getCollapsedSeeMoreText(text: string): string {
    if (!text || text.length <= this.seeMoreLength) {
      return text;
    }

    return text.substring(0, this.seeMoreLength) + '...';
  }

  generateUniqueIdSeeMore(collapsedText: string, expandedText: string): { seeMoreId: string; transcriptionId: string } {
    const seeMoreId = 'smtc' + Math.random().toString(36).substring(2);
    const transcriptionId = 'tc' + Math.random().toString(36).substring(2);

    this.seeMoreTranscriptionItems[seeMoreId] = {
      transcriptionId,
      collapsedText,
      expandedText,
    };

    return { seeMoreId, transcriptionId };
  }

  setSendAndRead(msg): string {
    // status_envio_id
    const audioExtensions = [".mp3", ".wav", ".ogg", ".flac", ".aac", ".m4a"];
    if (msg && msg.message && msg.tipo === 'anexo' && audioExtensions.some(extension => msg.message.endsWith(extension))) {
      switch (msg.status_envio_id) {
        case 0:
          return '<span class="error-time">&nbsp&nbspx</span></div>';
        case 1:
          return '<span class="read-time"><i class="fa-regular fa-clock" style="font-size: 12px; margin-left: 8px;"></i></span></div>';
        case 2:
          return '<span class="send-time">&nbsp&nbsp✓</span></div>';
        case 3:
          return '<span class="send-time">&nbsp&nbsp✓✓</span></div>';
        case 4:
          return '<span class="send-time">&nbsp&nbsp✓✓</span></div>';
        case 5:
          return '<span class="check-time">&nbsp&nbsp✓✓</span></div>';
        default:
          return '<span class="send-time">&nbsp&nbsp✓</span></div>';
      }
    } else if (msg.status_mensagem) {
      switch (msg.status_mensagem) {
        case 1:
          return '<span class="send-time">&nbsp&nbsp✓</span></div>';
        case 2:
          return '<span class="check-time">&nbsp&nbsp✓✓</span></div>';
        case 3:
          return '<span class="check-time">&nbsp&nbsp✓✓</span></div>';
        case 4:
          return '<span class="error-time">&nbsp&nbspx</span></div>';
        case 5:
          return '<span class="send-time">&nbsp&nbsp✓✓</span></div>';
        default:
          return "</div>";
      }
    } else {
      switch (msg.status_envio_id) {
        // case 1:
        //   return '<span class="read-time"><i class="fa-regular fa-clock" style="font-size: 12px; margin-left: 8px;"></i></span></div>';
        case 1:
          return '<span class="send-time">&nbsp&nbsp✓</span></div>';
        case 3:
          return '<span class="send-time">&nbsp&nbsp✓✓</span></div>';
        case 4:
          return '<span class="check-time">&nbsp&nbsp✓✓</span></div>';
        case 5:
          return '<span class="check-time">&nbsp&nbspx</span></div>';
        default:
          return "</div>";
      }
    }
  }

  mudouStatusMsg(msg): void {
    if (!msg) {
      return;
    }

    const indiceMensagem = this.buscarIndiceMensagemNaListagem(msg);
    if (indiceMensagem === -1) {
      return;
    }

    const mensagemAtualizada = {
      ...this.mensagensChat[indiceMensagem],
      ...msg,
      is_local: false
    };

    this.formatBodyMsg(mensagemAtualizada, 'interno');
    this.mensagensChat[indiceMensagem] = mensagemAtualizada;
  }

  trackById(index: number, item: any): number {
    return item.id; // Aqui você retorna o identificador único de cada item
  }

  setMediaMsg(msg_body, messageParsed, source, msg): string {
    let format = messageParsed[messageParsed.length - 1];
    let linkcheck = msg_body.split("https:");
    let linkcheckS = msg_body.split("http:");

    switch (format) {
      case "png":
      case "jpg":
      case "jpeg":
      case "bmp":
        if (source !== 'interno' && msg.transcricao_imagem) {
          return (
            '<a target="_blank" href="' +
            msg_body +
            '"><img width="400" height="300"  src="' +
            msg_body +
            '" />download</a>' + this.transcriptImage(msg)
          );
        } else {
          return (
            '<a target="_blank" href="' +
            msg_body +
            '"><img width="400" height="300"  src="' +
            msg_body +
            '" /></a>'
          );
        }
      case "opus":
      case "mp3":
      case "ogg":
      case "wav":
      case "oga":
      case "mpeg":
        if (source !== 'interno' && msg.resumo_audio && msg.transcricao_audio) {
          return (
            "<audio controls><source src=" +
            msg_body +
            ' type="audio/mpeg"></audio><br><a target="_blank" href="' +
            msg_body +
            '">download </a>' + this.transcriptAudio(msg)
          );
        } else {
          return (
            "<audio controls><source src=" +
            msg_body +
            ' type="audio/mpeg"></audio><br><a target="_blank" href="' +
            msg_body +
            '">download </a>'
          );
        }
      case "mp4":
        if (msg_body.includes('audio_')) {
          return (
            "<audio controls><source src=" +
            msg_body +
            ' type="audio/mp4"></audio><br><a target="_blank" href="' +
            msg_body +
            '">download </a>'
          );
        } else {
          return (
            '<video width="400" height="300" controls><source src="' +
            msg_body +
            '" type="video/mp4"></video><br><a target="_blank" href="' +
            msg_body +
            '">download </a>'
          );
        }
      case "zip":
      case "rar":
      case "msi":
        if (linkcheck.length > 1 || linkcheckS.length > 1) {
          return (
            '<a target="_blank" href="' +
            msg_body +
            '">' +
            this.translate.instant("CLIQUE_AQUI_BAIXAR") +
            "</a>"
          );
        } else {
          return msg_body;
        }
      default:
        let index = msg_body.indexOf("http");
        if (index !== -1) {
          return msg_body.replace(/https?:\/\/[^\s<]+/gi, (matchedUrl, offset, fullText) => {
            const { url, suffix } = this.splitTrailingUrlSuffix(matchedUrl, fullText, offset);
            const fileName = msg && msg.fileName ? msg.fileName : url;
            return `<a target="_blank" href="${url}">${fileName}</a>${suffix}`;
          });
        } else {
          return msg_body;
        }
    }
  }

  setMediaMsgResposta(msg_body, messageParsed): string {
    let format = messageParsed[messageParsed.length - 1];

    switch (format) {
      case "png":
      case "jpg":
      case "jpeg":
      case "bmp":
        return (
          '<i class="fa-light fa-image"></i> ' + format
        );
      case "opus":
      case "mp3":
      case "ogg":
      case "wav":
      case "oga":
      case "mpeg":
        return (
          '<i class="fa-light fa-microphone"></i> ' + format
        );
      case "mp4":
        return (
          '<i class="fa-duotone fa-regular fa-film"></i> ' + format
        );
      case "zip":
      case "rar":
      case "msi":
        return (
          '<i class="fa-light fa-file-zipper"></i> ' + format
        );
      case "pdf":
        return (
          '<div style="word-break: break-word; overflow-wrap: break-word;"><i class="fa-light fa-file-pdf"></i> ' + msg_body + '</div>'
        );
      default:
        return (
          '<div style="word-break: break-word; overflow-wrap: break-word;"><i class="fa-light fa-file"></i> ' + msg_body + '</div>'
        );
    }
  }

  formatLastMsg(last_msg, chat, noParse?: boolean): string {
    const ResolutionScreen = this.funcoesGlobaisService.getResolutionScreen();
    const ellipsisLimit = ResolutionScreen === "FULL HD" ? 35 : 20;

    if (!last_msg) {
      return this.ellipsisPipe.transform(last_msg, ellipsisLimit);
    }

    if (last_msg.includes('"nome_contato"') && !noParse) {
      const messageParsed = JSON.parse(last_msg);
      const nome_contatos = (messageParsed || []).map(m => m.nome_contato);
      return '<i class="fas fa-address-card mr-2"></i><span>' + this.translate.instant('CONTATO') + ' (' + nome_contatos.join(', ') + ')</span>';
    } else if (
      last_msg.includes('.opus') ||
      last_msg.includes('.mp3') ||
      last_msg.includes('.ogg') ||
      last_msg.includes('.wav') ||
      last_msg.includes('.oga') ||
      last_msg.includes('.mpeg')
    ) {
      return '<i class="fas fa-music mr-2"></i><span>Audio</span>';
    } else if (last_msg.includes('.mp4')) {
      return '<i class="fas fa-video mr-2"></i><span>Video</span>';
    } else if (
      last_msg.includes('.zip') ||
      last_msg.includes('.rar') ||
      last_msg.includes('.msi')
    ) {
      return '<i class="fas fa-file mr-2"></i><span>' + this.translate.instant('ARQUIVO') + '</span>';
    } else if (
      last_msg.includes('.png') ||
      last_msg.includes('.jpg') ||
      last_msg.includes('.jpeg') ||
      last_msg.includes('.bmp')
    ) {
      return '<i class="fas fa-image mr-2"></i><span>' + this.translate.instant('IMAGEM') + '</span>';
    } else if (chat.is_whatsapp) {
      last_msg = this.applyWppFormat(last_msg);
      // return last_msg;
      return this.ellipsisPipe.transform(last_msg, ellipsisLimit);
    } else {
      return this.ellipsisPipe.transform(last_msg, ellipsisLimit);
    }
  }

  formatLastMsgName(chat): string {
    const ResolutionScreen = this.funcoesGlobaisService.getResolutionScreen();
    const ellipsisLimit = ResolutionScreen === "FULL HD" ? 25 : 15;

    const desc = chat?.contato?.descricao?.toString().trim();
    if (desc) return this.ellipsisPipe.transform(desc, ellipsisLimit);

    const email = chat?.contato?.email?.toString().trim();
    if (email) return email;

    const tel = chat?.contato?.telefone?.toString().trim();
    if (tel) return this.ellipsisPipe.transform(tel, ellipsisLimit);

    const numero = chat?.numero_contato?.toString().trim();
    if (numero) return numero;

    return this.translate.instant('SEM_CONTATO_CADASTRADO');
  }

  abrirModalContato(multiplo?, continuacao?): void {
    const modalRef = this.modalService.open(ModalContatosComponent, {
      scrollable: false,
      windowClass: 'modal-custom-milvus',
      size: 'medio',
      keyboard: false,
      backdrop: 'static'
    });

    let contato = this.chatSelecionado?.contato;
    if (!contato) {
      const numeroContato = this.chatSelecionado?.numero_contato?.toString() || '';
      const prefixoInternacional = numeroContato.match(/^\s*(\+|00)/)?.[1];
      const possuiPrefixoInternacional = !!prefixoInternacional;
      let ddi = (this.chatSelecionado?.codigo_pais || this.chatSelecionado?.ddi)?.toString().replace(/\D/g, '') || '';
      let celular = numeroContato.replace(/\D/g, '');

      if (prefixoInternacional === '00') {
        celular = celular.substring(2);
      }

      const pareceNumeroBrasileiroLocal = (numero: string): boolean => {
        if (numero.length !== 10 && numero.length !== 11) return false;

        const ddd = numero.substring(0, 2);
        const primeiroDigitoAssinante = numero.charAt(2);

        if (!/^[1-9]\d$/.test(ddd) || !/^[2-9]$/.test(primeiroDigitoAssinante)) return false;

        return numero.length === 10 || primeiroDigitoAssinante === '9';
      };

      const eh0800SemDdi = celular.startsWith('0800');

      const possuiZeroTroncoNacional = !possuiPrefixoInternacional
        && celular.startsWith('0')
        && !eh0800SemDdi
        && pareceNumeroBrasileiroLocal(celular.substring(1));

      if (possuiZeroTroncoNacional) {
        celular = celular.substring(1);
      }

      if (!ddi && celular && !eh0800SemDdi) {
        if (possuiPrefixoInternacional) {
          if (celular.startsWith('55')) {
            ddi = '55';
          }
        } else if (
          pareceNumeroBrasileiroLocal(celular)
          || (celular.startsWith('55') && pareceNumeroBrasileiroLocal(celular.substring(2)))
        ) {
          ddi = '55';
        }
      }

      const possuiDdiBrasileiro = ddi === '55' && celular.startsWith(ddi) && celular.length > 11;
      if (ddi && celular.startsWith(ddi) && (possuiPrefixoInternacional || possuiDdiBrasileiro)) {
        celular = celular.substring(ddi.length);
      }

      const eh0800 = celular.startsWith('0800');
      if (eh0800) {
        ddi = '';
      } else {
        const primeiroDigitoAssinante = celular.charAt(2);
        const ehCelularLegado = ddi === '55' && celular.length === 10 && /^[689]$/.test(primeiroDigitoAssinante);

        if (ehCelularLegado) {
          celular = celular.substring(0, 2) + '9' + celular.substring(2);
        }
      }

      contato = {
        celular: celular,
        codigo_pais: ddi,
        codigo_pais_id: ddi
          ? this.chatSelecionado?.codigo_pais_id || this.chatSelecionado?.ddi_id || (ddi === '55' ? 152 : null)
          : null
      };
    }
    if (this.chatSelecionado.cliente) {
      contato.cliente = this.chatSelecionado.cliente;
      contato.cliente_id = this.chatSelecionado.cliente_id || this.chatSelecionado.cliente.id;
    }

    modalRef.componentInstance.add_via_chat = true;
    modalRef.componentInstance.contato = { ...contato, chat_id: this.chatSelecionado?._id };
    modalRef.componentInstance.solicitantes = this.solicitantes_habilitados;
    modalRef.componentInstance.is_chat_email = this.chatSelecionado.is_chat_email;
    if (multiplo) {
      if (continuacao) {
        modalRef.componentInstance.multiplo = continuacao === 'encerrarCriar'
          ? this.chatSelecionado?.contato_multiplos_tickets
            ? this.chatSelecionado?.contato_multiplos_tickets
            : this.chatSelecionado?.contato_multiplos
          : this.chatSelecionado?.contato_multiplos;
      } else {
        modalRef.componentInstance.multiplo = this.chatSelecionado.contato_multiplos;
      }
    }

    modalRef.result.then(results => {
      if (results) {
        this.chatSelecionado.contato = results.chat;
        this.chatSelecionado.contato_id = results.chat.id;
        if (results.cliente) {
          this.chatSelecionado.cliente = results.cliente;
          this.chatSelecionado.cliente_id = results.cliente.id;
        }

        this.listaChats?.forEach(chat => {
          if (chat?._id === this.chatSelecionado?._id) {
            chat.contato = results.chat;
          }
        });

        if (continuacao) {
          setTimeout(() => {
            switch (continuacao) {
              case 'encerrar':
                this.abrirModalFinalizar(this.chatSelecionado);
                break;
              case 'encerrarCriar':
                this.encerrarCriarTicket(this.chatSelecionado);
                break;
              case 'associar':
                this.conciliarTicket(this.chatSelecionado);
                break;
            }
          }, 0);
        }
      }
    });
  }

  verificaVisibilidadeConciliacao(chat): boolean {
    if (!this.solicitantes_habilitados.solicitante_cliente && !this.solicitantes_habilitados.solicitante_contato) {
      return false;
    } else if (chat.contato?.id) {
      return chat.cliente_id ? true : false;
    } else {
      const semChamado = !chat?.chamado_id && !chat?.chamado_vinculado;
      return this.permissao.VisualizarTickets && semChamado;
    }
  }

  obterIntegracaoChatGPT() {
    this.newSubs = this.integrationService.getChatGPTIntegrationStatus().subscribe(
      {
        next: (result) => {
          if (result) {
            this.allowChatGPT = result.apoio_para_chat !== IaConfiguracaoAcaoFonteEnum.NENHUMA;
          }
        },
        error: (error) => console.error('obterIntegracaoChatGPT', error)
      }
    )
  }

  generateChatGPT() {
    const inputText = this.createAnswerToChat.controls.chatGPT.value;

    // Validação: não faz busca se o input estiver vazio
    if (!inputText || inputText.trim().length === 0) {
      this.toastr.show(
        "Por favor, insira um texto para pesquisar.",
        "",
        environment.toastrConfig("warning")
      );
      return;
    }

    let payload = {
      texto: inputText,
      feature_id: IaConfiguracaoFeatureEnum.APOIO_CHAT
    };

    const modalRefLoadingGpt = this.modalService.open(ModalOpenAITemplateComponent, {
      backdrop: "static",
      windowClass: "modal-custom-milvus",
      keyboard: true,
      size: "grande",
      scrollable: false,
    });

    modalRefLoadingGpt.componentInstance.apenasLoading = true;
    modalRefLoadingGpt.componentInstance.carregando = true;

    this.newSubs = this.chatGPTService.searchSuggestion(payload).subscribe({
      next: (result) => {
        this.toastr.show(
          result.mensagem,
          "",
          environment.toastrConfig("success")
        );

        this.chatGPTSuggestion = result.data.texto_html.replaceAll('\n', '<br>');
        this.chatGPTSuggestionCopy = result.data.texto;
        modalRefLoadingGpt.componentInstance.carregando = false;
      },
      error: (error) => console.error('generateChatGPT', error)
    });
  }

  copy(chatBox, scrollMe) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.chatGPTSuggestionCopy;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.mensagem = this.chatGPTSuggestionCopy;
    this.autoGrow('', chatBox.nativeElement, scrollMe.nativeElement);

    this.toastr.show(
      this.translate.instant('COPIADO_SUCESSO'),
      '',
      environment.toastrConfig('success')
    );
  }

  limparSugestao(): void {
    this.chatGPTSuggestion = null;
    this.chatGPTSuggestionCopy = null;
  }

  getAIColumnClass(): string {
    return this.isAIExpanded ? 'col-3' : 'col-2';
  }

  expandAI() {
    this.isAIExpanded = true;
  }

  collapseAI() {
    this.isAIExpanded = false;
    setTimeout(() => {
    }, 10);
  }

  onAIInteraction(event: Event) {
    event.stopPropagation();
    this.expandAI();
  }

  onChatAreaClick() {
    this.collapseAI();
  }

  retornaMascaraNum(numero): string {
    // if (numero.length === 11) {
    //   return '(00) 0 0000-0000';
    // } else {
    //   return '(00) 0000-0000';
    // }
    if (!numero) {
      return '';
    }

    return CountriesMask(numero.toString().length, numero.toString());
  }

  visualizarArquivo(msg: any, event: any) {
    if (event.target && (event.target.classList.contains('see-more-transcription') || event.target.closest('.see-more-transcription'))) {
      return;
    }

    if (!event.ctrlKey) {
      let arquivo = '';
      event.preventDefault();

      if (msg.tipo !== 'texto' && msg.enviado_por !== 'robo') {
        if (msg && typeof msg === 'string') {
          arquivo = msg
        } else if (msg && msg.msg && msg.msg.match(/\.\w+$/)) {
          arquivo = msg.msg
        } else if (msg && msg.body && msg.body.match(/\.\w+$/)) {
          arquivo = msg.body
        } else if (msg && msg.resposta_message && msg.resposta_message.match(/\.\w+$/)) {
          arquivo = msg.resposta_message
        }
      } else if (event.target['localName'] === 'a') {
        arquivo = event.target['href'];
      } else {
        return;
      }

      if (
        (arquivo.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i) ||
          arquivo.match(/\.(mp3|wav|ogg)$/i) ||
          arquivo.match(/\.(mp4|webm|ogg|mov)$/i) ||
          arquivo.match(/\.pdf$/i)) && (!this.provider_id_conversa || this.provider_id_conversa === 4)
      ) {
        const modalRef = this.modalService.open(VisualizadorArquivosComponent, {
          scrollable: false,
          windowClass: 'modal-custom-arquivos',
          size: 'grande',
          keyboard: true,
        });

        modalRef.componentInstance.fileUrl = arquivo;
      } else {
        this.baixarArquivo(arquivo);
      }
    }
  }

  scrollToMessage(msg: any) {

    const { resposta_message_id, message_id } = msg;

    const msgFiltrada = this.mensagensChat.find(mensagem => {
      return (resposta_message_id && mensagem.id === resposta_message_id) ||
        (resposta_message_id && mensagem.whatsapp_id === resposta_message_id) ||
        (message_id && mensagem.message_id === message_id)
    });

    if (!msgFiltrada || !msgFiltrada.id) {
      return;
    }

    const element = document.getElementById(msgFiltrada.id);

    console.log("element", element);
    if (element && element.parentElement?.parentElement?.parentElement) {
      element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });


      element.parentElement.parentElement?.parentElement.classList.add('smooth-transition');

      element.parentElement.parentElement.parentElement.style.backgroundColor = 'rgba(154, 229, 169, 0.1)';
      setTimeout(() => {
        element.parentElement.parentElement.parentElement.style.backgroundColor = '';
      }, 2000);
    }
  }

  responderMensagem(msg) {
    if (this.chatSelecionado?.is_whatsapp && this.chatSelecionado?.status_id === 2 && !msg.is_tranferencia) {
      msg.body = msg.body || msg.msg;

      if (msg.tipo !== 'texto') {

        const midia = this.setMediaMsgResposta(msg.body, msg.body.split('.'));
        this.respostaSelecionada = msg;
        this.respostaSelecionada.midia = midia
      } else {
        this.respostaSelecionada = msg;
      }
      const element = document.getElementById('msg-item');
      if (element) {
        element.style.bottom = '250px';
      }

      const elementclicked = document.getElementById(msg.id);
      if (elementclicked) {

        elementclicked.parentElement.parentElement.parentElement.classList.add('smooth-transition');

        elementclicked.parentElement.parentElement.parentElement.style.backgroundColor = 'rgba(154, 229, 169, 0.1)';
        setTimeout(() => {
          elementclicked.parentElement.parentElement.parentElement.style.backgroundColor = '';
        }, 2000);
      }
    }
  }

  removeResposta() {
    this.respostaSelecionada = null;

    const element = document.getElementById('msg-item');
    if (element) {
      element.style.bottom = '193px';
    }
  }

  async buscarContatoDropdowns(chat) {

    try {

      const chatId = chat?._id;

      if (!chatId) {
        console.log('buscarContatoDropdowns - sem chatId');
        return;
      }

      const contatos = await this.chatService.buscarContatoDropdowns(chat);

      if (!contatos) {
        console.log('buscarContatoDropdowns - sem contatos');
        return;
      }

      chat.contato_multiplos_tickets = contatos.contato_multiplos_tickets;
      chat.contato_multiplos = contatos.contato_multiplos;

      // backend pode ter resolvido e vinculado o contato pelo numero normalizado
      // (chat iniciado pelo cliente sem contato_id ainda persistido)
      if (contatos.contato_id && contatos.contato) {
        const clienteResolvido = contatos.cliente || contatos.contato.cliente;
        const clienteIdResolvido = contatos.cliente_id || contatos.contato.cliente_id || clienteResolvido?.id;

        chat.contato_id = contatos.contato_id;
        chat.contato = contatos.contato;
        if (clienteIdResolvido != null) chat.cliente_id = clienteIdResolvido;
        if (clienteResolvido) chat.cliente = clienteResolvido;
      }

      if (this.chatSelecionado?._id === chatId) {
        this.chatSelecionado.contato_multiplos_tickets = contatos.contato_multiplos_tickets;
        this.chatSelecionado.contato_multiplos = contatos.contato_multiplos;

        if (contatos.contato_id && contatos.contato) {
          const clienteResolvido = contatos.cliente || contatos.contato.cliente;
          const clienteIdResolvido = contatos.cliente_id || contatos.contato.cliente_id || clienteResolvido?.id;

          this.chatSelecionado.contato_id = contatos.contato_id;
          this.chatSelecionado.contato = contatos.contato;
          if (clienteIdResolvido != null) this.chatSelecionado.cliente_id = clienteIdResolvido;
          if (clienteResolvido) this.chatSelecionado.cliente = clienteResolvido;
        }
      }
    } catch (error) {
      console.error('buscarContatoDropdowns - error: ', error);
    }
  }

  showReply(index: number) {
    this.activeIndex = this.activeIndex === index ? null : index;

  }

  salvarContato(contato: any) {
    if (contato.botao) {
      this.iniciarConversa(contato);
    } else {

      const modalRef = this.modalService.open(ModalContatosComponent, {
        scrollable: false,
        windowClass: 'modal-custom-milvus',
        size: 'medio',
        keyboard: false,
        backdrop: 'static'
      });

      const salvarContato = {
        codigo_pais_id: contato.codigo_pais_id ? contato.codigo_pais_id : 152,
        celular: contato.celular,
        descricao: contato.nome_contato,
        codigo_pais: contato.ddi ? contato.ddi : 55,
      }

      modalRef.componentInstance.solicitantes = this.solicitantes_habilitados;
      modalRef.componentInstance.contato = salvarContato;
      modalRef.componentInstance.origem_chat = true;
      modalRef.result.then(result => {
        if (result) {
          contato.salvo = result.chat;
          contato.botao = true;
          if (result.conversar) {
            this.iniciarConversa(result.chat);
          }
        }
      });
    }
  }

  iniciarConversa(contato: any) {
    if (contato.clientes && contato.clientes.length > 1) {
      const modalRef = this.modalService.open(ModalClienteContatoComponent, {
        scrollable: true,
        windowClass: 'modal-custom-milvus',
        size: 'pequeno',
        keyboard: false,
        backdrop: 'static',
      });

      modalRef.componentInstance.data = contato;

      modalRef.result.then((results) => {
        if (results) {
          this.loadChats();
          this.chatAtivoId = results._id;
          this.abrirChat(results);
        }
      });

    } else {
      if (!this.hasIntegracao) {
        Swal.fire({
          title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_INTEGRACAO'),
          icon: 'info',
          confirmButtonText: "Ok",
          position: "top"
        });

        return;
      }

      this.newSubs = this.chatService.obterIntegracaoAtivaSaida()
        .subscribe({
          next: (results) => {
            if (results.dropDown.length) {
              if (!results.filasAtivas.length) {
                Swal.fire({
                  title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_FILA'),
                  icon: 'info',
                  confirmButtonText: 'Ok',
                  position: 'top'
                });
                return;
              } else if (!results.integracoes.length) {
                Swal.fire({
                  title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_NUM_SAIDA'),
                  icon: 'info',
                  confirmButtonText: 'Ok',
                  position: 'top'
                });
                return;
              } else {
                const modalRef = this.modalService.open(ModalMsgStartChatWhatsappComponent, {
                  scrollable: true,
                  windowClass: 'modal-custom-milvus',
                  size: 'medio',
                  keyboard: false,
                  backdrop: 'static',
                });

                let data = {
                  provider_id: results?.provider_id,
                  number: contato.celular,
                  integration_id: results?.id,
                  ...results
                };

                if (results?.provider_id === 2) {
                  data['message'] = results?.mensagem_inicia_conversa_whatsapp
                };

                modalRef.componentInstance.data = data;
                modalRef.result.then(
                  (result) => {
                    if (result && result.provider_id) {
                      var _contato = result;

                      if (contato.salvo) {
                        _contato.from = results.numero;
                        _contato.numero_destino = contato.salvo.celular;
                        _contato.contato_id = contato.salvo.clientes_id;
                        _contato.numero_contato = contato.salvo.celular;
                        _contato.chamado_id = null;
                        _contato.nome_contato = contato.salvo.descricao;
                        _contato.contato_id = contato.salvo.id;
                        _contato.cliente_id = contato.salvo.clientes_id;
                      } else {
                        _contato.from = results.numero;
                        _contato.numero_destino = contato.celular;
                        _contato.contato_id = contato.clientes && contato.clientes[0].id ? contato.clientes[0].id : contato.clientes_id;
                        _contato.numero_contato = contato.celular;
                        _contato.chamado_id = null;
                        _contato.nome_contato = contato.nome_contato || contato.descricao;
                        _contato.contato_id = contato.clientes && contato.clientes[0].id ? contato.clientes[0].id : contato.id;
                        _contato.cliente_id = contato.clientes && contato.clientes[0].id ? contato.clientes[0].id : contato.clientes_id;
                      }



                      this.newSubs = this.whatsappService
                        .wppIniciarConversaUnificado(_contato)
                        .subscribe(
                          (results) => {
                            this.loadChats();
                            this.chatAtivoId = results._id;
                            this.abrirChat(results.chat);
                          },
                          error => console.error('iniciarConversa', error)
                        );
                    }
                  }
                )
              }
            } else {
              Swal.fire({
                title: this.translate.instant('AVISO_INICIAR_CONVERSA_SEM_INTEGRACAO'),
                icon: 'info',
                confirmButtonText: "Ok",
                position: "top"
              });
            }
          },
          error: (error) => console.error('iniciarConversa', error)
        });
    }
  }

  private baixarArquivo(fileUrl: string, fileName?: string): void {
    if (fileUrl.match(/\.(html|css|js|ts|xml|json)$/i)) {
      fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileUrl.split('/').pop() || 'download';
          link.click();
        })
        .catch(console.error);
    } else {
      const anchor = document.createElement('a');
      anchor.href = fileUrl;
      anchor.download = fileUrl.split('/').pop() || 'download';
      anchor.target = '_blank';
      anchor.click();
    }
  }

  validarIntegracao() {
    this.newSubs = this.chatService.obterIntegracaoAtivaSaida()
      .subscribe({
        next: result => {
          if (result) {
            this.integracaoCompleta = true;
          }
        },
        error: error => console.error('validarIntegracao', error)
      })
  }

  buscaGuardaQntChatSalvo(buscar: boolean, resetar?: boolean): any {
    let chave = 'qcps' + this.statusSelecionado;
    if (buscar) {
      let valor = localStorage.getItem(chave);
      return valor ? parseInt(valor) : 15;
    }

    if (resetar) {
      localStorage.removeItem('qcps1');
      localStorage.removeItem('qcps2');
      localStorage.removeItem('qcps3');
    } else {
      localStorage.setItem(chave, this.offSetChats.toString());
    }
  }

  private scrollToSelectedChat(): void {

    if (!this.chatSelecionado?._id) {
      return;
    }

    if (!this.chatList?.nativeElement) {
      setTimeout(() => this.scrollToSelectedChat(), 0);
      return;
    }

    setTimeout(() => {
      if (!this.chatSelecionado?._id || !this.chatList?.nativeElement) {
        return;
      }

      const chatListElement = this.chatList.nativeElement as HTMLElement;
      const selectedChatElement = chatListElement.querySelector(
        `[data-chat-id="${this.chatSelecionado._id}"]`
      ) as HTMLElement;

      if (!selectedChatElement) {
        return;
      }

      const elementOffsetTop = selectedChatElement.offsetTop;
      const elementHeight = selectedChatElement.offsetHeight || 0;
      const containerHeight = chatListElement.clientHeight || 0;
      const offset = elementOffsetTop - (containerHeight / 2) + (elementHeight / 2);

      chatListElement.scrollTop = offset < 0 ? 0 : offset;
    }, 0);
  }

  verificarEAbrirModalErro131047(msg: any): void {
    const messageId = msg.id || msg.message_id || msg.whatsapp_id || `${msg.chat_id}-${msg.timestamp}`;

    if (!this.erro131047JaExibido.get(messageId)) {
      this.erro131047JaExibido.set(messageId, true);
      this.abrirModalEnvioWhatsApp(true, msg);
    }
  }

  selecionarMensagem(msg): void {
    if (!msg.selecionada) {
      msg.selecionada = true;
      this.msgSelecionadas.push(msg);
    } else {
      delete msg.selecionada;
      this.msgSelecionadas = this.msgSelecionadas.filter(x => x.id !== msg.id);
    }
  }

  removerSelecaoMsgs(): void {
    this.mensagensChat.forEach(msg => {
      delete msg.selecionada;
    });
    this.msgSelecionadas = [];
  }

  clickSelecionaMensagem(msg, event): void {
    if (event.ctrlKey) {
      if (!msg.is_tranferencia && msg.enviado_por !== 'robo') {
        this.selecionarMensagem(msg);
      }
    }
  }

  verificaMostraScrollBtn(historico?: boolean): boolean {
    if (historico) {
      return (this.myScrollContainer?.nativeElement.scrollHeight - this.myScrollContainer?.nativeElement.scrollTop) > 600;
    } else {
      return (this.myScrollContainer?.nativeElement.scrollHeight - this.myScrollContainer?.nativeElement.scrollTop) > 1000;
    }
  }

  mudaAddOn(aba): void {
    this.addOnTab = aba;
    if (aba === 1) {
      localStorage.removeItem('abaChat');
    } else {
      localStorage.setItem('abaChat', aba);
    }
  }

  obterTemplatesChat(): void {
    if (this.chatSelecionado?.is_chat_email) {
      this.templatesChat = [];
      if (this.addOnTab === 2) {
        this.mudaAddOn(1);
      }
      return;
    }
    const payload = {
      filtro_body: {
        is_ativo: true,
        tipo_template_id: this.chatSelecionado.is_chat_email ? 2 : 6,
        fila_atendimento_chat_id: this.chatSelecionado?.fila_atendimento_id ?? null
      },
      inclui_meta: this.chatSelecionado.whatsapp_oficial,
      somente_meta: this.verificaMostraApenasTemplatesMeta()
    };

    this.newSubs = this.configTemplatesService.listagemTemplates({}, payload)
      .subscribe({
        next: (results) => {

          if (results) {

            let templatesTraduzidos = this.traduzirTemplatesMeta(results, false);

            this.templatesChat = templatesTraduzidos;

            if (!this.allowChatGPT && this.templatesChat && this.templatesChat.length > 0 && this.addOnTab === 1) {
              this.mudaAddOn(2);
            }

            if (this.allowChatGPT && (!this.templatesChat || this.templatesChat.length === 0) && this.addOnTab === 2) {
              this.mudaAddOn(1);
            }

          }
        }, error: (error) => console.error('obterTemplatesChat', error)
      });
  }

  traduzTemplateAddBox(template, chatBox, scrollMe): void {
    const entidadeId = this.chatAtivoId || this.chatSelecionado?._id;
    this.newSubs = this.templatesService.traduzirTemplate(template.id, entidadeId)
      .subscribe({
        next: (results) => {
          if (results) {

            let templatesTraduzidos = this.traduzirTemplatesMeta(results, true);

            let filteredString = templatesTraduzidos.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
            filteredString = filteredString.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '');
            filteredString = filteredString.replace(/(?<!^)<p([^>]*)>/gi, '\n');
            filteredString = filteredString.replace(/<\/p([^>]*)>/gi, '');
            let _element = document.createElement('div');
            _element.setAttribute('style', 'display: none');
            _element.innerHTML = filteredString;
            this.mensagem += _element.innerText;
            this.autoGrow('', chatBox.nativeElement, scrollMe.nativeElement);
          }
        }, error: (error) => {
          console.error('traduzTemplateAddBox', error);
        }
      });
  }

  verificaMostraApenasTemplatesMeta(): boolean {
    if (this.chatSelecionado.whatsapp_oficial) {
      const regra_msgs = this.mensagensChat && this.mensagensChat.length ? this.mensagensChat.filter(m => m.enviado_por === 'cliente') : false;
      if (regra_msgs.length) { //verifica se última msg faz 24h
        const agora: any = new Date();
        const ultima_msg: any = new Date(regra_msgs[regra_msgs.length - 1].data_mensagem);
        const diff = new moment.duration(agora - ultima_msg);
        this.templatesSomenteMeta = Math.floor(diff.asSeconds()) >= 86400;
        return Math.floor(diff.asSeconds()) >= 86400;
      }
      this.templatesSomenteMeta = true;
      return true;
    } else {
      this.templatesSomenteMeta = false;
      return false;
    }
  }

  obterDados() {
    this.newSubs = this.dadosEmpresaService.obterDados().subscribe(
      (result) => {
        const res = (result as any)?.result || (result as any)?.results || result;
        if (res && res.empresa) {
          Object.keys(res.empresa).forEach((e) => {
            res.empresa[e] = (res.empresa[e] === null || res.empresa[e] === undefined) ? '' : res.empresa[e]
          })
        }
        this.nomeEmpresa = result?.empresa?.nome_fantasia ? result.empresa.nome_fantasia : '';
      }, (error) => console.error('obterDados', error)
    )
  }

  private limparDescricaoTemplateChat(texto: string): string {
    if (!texto) {
      return texto;
    }

    return texto
      .replace(/\t+/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  traduzirTemplatesMeta(results, box) {
    let templatesTraduzidos = [];

    const marcadores = [
      { chave: '{{Contato}}', valor: this.chatSelecionado?.contato?.descricao },
      { chave: '{{Empresa}}', valor: this.nomeEmpresa },
      { chave: '{{Operador}}', valor: this.operador },
      { chave: '{{Ticket}}', valor: "Não Possui" },
      { chave: '{{Protocolo}}', valor: this.chatSelecionado?.protocolo || "Não Possui" },
      { chave: '{{Assunto}}', valor: "Não Possui" },
      { chave: '{{contato}}', valor: this.chatSelecionado?.contato?.descricao },
      { chave: '{{empresa}}', valor: this.nomeEmpresa },
      { chave: '{{operador}}', valor: this.operador },
      { chave: '{{ticket}}', valor: "Não Possui" },
      { chave: '{{protocolo}}', valor: this.chatSelecionado?.protocolo || "Não Possui" },
      { chave: '{{assunto}}', valor: "Não Possui" }
    ];

    if (box) {
      let resultado = results.descricao_html ? results.descricao_html : results;

      const substituirMarcadores = (texto: string) =>
        marcadores.reduce((acc, m) => acc?.replaceAll(m.chave, m.valor), texto);

      resultado = substituirMarcadores(resultado);

      return resultado;
    }

    let resultado = results.lista ? results.lista : results;

    resultado.forEach((properties) => {

      const substituirMarcadores = (texto: string) =>
        marcadores.reduce((acc, m) => acc?.replaceAll(m.chave, m.valor), texto);

      properties.descricao_html = this.limparDescricaoTemplateChat(
        substituirMarcadores(properties.descricao_html)
      );

      templatesTraduzidos.push(properties);
    });

    return templatesTraduzidos;
  }

  marcarComoLidoEvento(): void {
    if (this.chatSelecionadoSocket && this.conectado) {
      this.chatSelecionadoSocket.emit('mensagens_visualizadas');
    }
  }

  verificaRecebeuUltimaMsg(recebido_realtime: any): void {
    if (!this.chatSelecionado || recebido_realtime?.chat_id !== this.chatSelecionado._id) {
      return;
    }
    if (this.deveIgnorarBuscaConversa(recebido_realtime)) {
      return;
    }
    if (!this.mensagensChat?.length) {
      return;
    }
    if (!recebido_realtime.id) {
      return;
    }

    // REMOVIDO PARA TESTES SE CAUSA O BUG REF: MIL-28915
    // const jaEstaNaLista = this.mensagensChat.some((m: any) => m?.id === recebido_realtime.id);
    // if (!jaEstaNaLista) {
    //   this.loadChatMessages(this.chatSelecionado._id);
    // }
  }

  checkIsOnline(event) {
    this.tokenData.is_online_chat = event;
    this.atualizarStatus();
  }

  checkAlertaChat(event) {
    this.tokenData.alerta_chat = event;
    this.atualizarStatus();
  }

  atualizarStatus(): void {
    var status = {
      is_online: this.tokenData.is_online_chat,
      alerta_chat: this.tokenData.alerta_chat,
    };

    this.newSubs = this.usuariosService.atualizarStatusChat(status).subscribe(
      (result) => {
        this.toastr.show(
          this.translate.instant("SALVO_SUCESSO"),
          "",
          environment.toastrConfig("success")
        );
        this.tokenService.setToken(this.tokenData);
        window.postMessage({
          tipo: 'mod_config_chats',
          user: this.tokenData
        });
        if (this.tokenData.alerta_chat) {
          this.alertasPushService.validaServiceWorker();
        }
      }, (error) => console.error('atualizarStatus', error)
    );
  }

  verificaNumerosDesconectados(): void {
    this.newSubs = this.chatService.buscaNumerosDesconectados()
      .subscribe({
        next: (results) => {
          if (results.numeros_desconectados) {
            this.numerosDesconectados = results.numeros_desconectados;
            this.numerosDesconectados.forEach((num: any) => {
              num.numero = this.mask.applyMask(num.numero, num.numero.length === 12 ? '+00 (00) 0000-0000' : '+00 (00) 00000-0000');
            });
          }
        }, error: (error) => {
          console.error('verificaNumerosDesconectados', error);
          clearInterval(this.intervalNumerosDesconectados);
        }
      });
  }

  porcentagemArquivo(size) {
    return (size / (1000 * 1000)).toFixed(2);
  }

  abrirArquivo(url: string): void {
    const validatedUrl = validateResourceUrl(url, {
      allowedDomains: EMAIL_ATTACHMENT_ALLOWED_DOMAINS
    });

    if (!validatedUrl) {
      return;
    }

    const openedWindow = window.open(validatedUrl, '_blank', 'noopener,noreferrer');
    if (openedWindow) {
      openedWindow.opener = null;
    }
  }

  bloquearRemetente(chat: any): void {
    const modalRef = this.modalService.open(ModalTicketRetidoBloquearEmailComponent, {
      backdrop: "static",
      windowClass: 'modal-custom-milvus',
      keyboard: false,
      scrollable: false,
      size: "medio",
    })

    let data = {
      bloquear_email: {
        cliente: chat.cliente,
        cliente_id: chat.cliente_id,
        email_cliente: chat.chat_email_ui?.cabecalho_email_remetente,
        id: chat._id
      }
    };

    modalRef.componentInstance.bloquear_email = data;
    modalRef.componentInstance.is_bloquear_email = false;
    modalRef.componentInstance.is_from_chat = true;
    modalRef.componentInstance.chat_id = this.chatSelecionado._id;

    modalRef.result.then((result) => {
      if (!result) {
        return;
      }
      this.newSubs = this.chatService.obterChatTecnico(this.chatAtivoId).subscribe(
        (apiResult) => {
          if (!apiResult?.chat) {
            return;
          }
          const ch = apiResult.chat;
          if (ch.status_id === 3) {
            this.statusSelecionado = 3;
            this.isAIExpanded = false;
            this.notificarChatFinalizado({ chat_id: this.chatAtivoId });
            this.listaChats = [];
            this.paginaChats = 1;
            this.offSetChats = this.buscaGuardaQntChatSalvo(true);
          }
          this.chatSelecionado = ch;
          this.abrirChat(ch, true);
          this.loadChats();
          this.loadContadores();
          this.cd.detectChanges();
        },
        error => console.error('obterChatTecnico', error)
      );
    });
  }

  private montarContextoListaContatosParaModalEmail(): any | null {
    const ch = this.chatSelecionado;
    if (!ch) {
      return null;
    }
    if (!ch.cliente && (ch.cliente_id == null || ch.cliente_id === '')) {
      return null;
    }
    const solicitante = ch.cliente;
    if (!solicitante && ch.cliente_id != null && ch.cliente_id !== '') {
      return {
        cliente: { id: ch.cliente_id, text: '' },
        contatosSelecionados: [],
        tipo_solicitante_id: 1,
        solicitante_id: ch.cliente_id,
      };
    }
    const tipo = solicitante.tipo_solicitante_id ?? 1;
    return {
      cliente: tipo === 1 ? solicitante : null,
      contatosSelecionados: [],
      tipo_solicitante_id: tipo,
      solicitante_id: solicitante.id ?? ch.cliente_id,
    };
  }

  responderMensagemEmail(msg: any): void {
    if (!msg) {
      msg = {
        chat_id: this.chatSelecionado._id,
        message_id: null
      };
    }
    const modalRef = this.modalService.open(ModalEnviarEmailComponent, {
      backdrop: "static",
      windowClass: "modal-custom-milvus",
      keyboard: false,
      size: "grande",
      scrollable: false,
      centered: false,
    });

    modalRef.componentInstance.chatEmailData = msg;
    modalRef.componentInstance.chatContatosContext =
      this.montarContextoListaContatosParaModalEmail();
    modalRef.result.then((results) => {
      if (results) {
        this.loadChatMessages(this.chatSelecionado._id);
      }
    });
  }

  visualizaOrigemRespostaEmail(msg: any): void {
    const { responde_mensagem_id, message_id } = msg;

    const msgFiltrada = this.mensagensChat.find(mensagem => {
      return (responde_mensagem_id && mensagem.id === responde_mensagem_id) ||
        (message_id && mensagem.message_id === message_id)
    });

    if (!msgFiltrada || !msgFiltrada.id) {
      return;
    }

    const element = document.getElementById(msgFiltrada.id);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      element.classList.add('smooth-transition');

      element.style.backgroundColor = 'rgba(154, 229, 169, 0.3)';
      setTimeout(() => {
        element.style.backgroundColor = '';
      }, 2000);
    }
  }

  enviaAnexoOutroChat(chatSelecionado: any, msg: any): void {
    var _msg = {
      user: this.tokenData?.nome,
      chat_id: chatSelecionado._id,
      enviado_por: "tecnico",
      tipo: "anexo",
      img: this.tokenData?.foto,
      msg: msg.link,
      message_id: null,
      token_widget: chatSelecionado.widget.token_widget,
      nome: this.tokenData?.nome,
      data: new Date(),
      message: msg,
      origem: 'gestor',
      body: msg,
    };

    this.chatService.enviarMsg(_msg)
      .subscribe({
        next: (results) => {
          chatSelecionado.ultima_mensagem = _msg.msg;
          chatSelecionado.data_mensagem = this.tokenService.convertDateTimezoneToView(new Date());
        }, error: (error) => {
          if (this.tratarErroEnvioChatFinalizado(error, _msg.chat_id)) {
            return;
          }
          console.error('autoMsgAnexo', error);
        }
      });
  }
}

function obterTagSessao(chat_id: string): string {
  const tag = 'chat-receive-log-' + chat_id;
  return tag;
}


function montaErroMsg(error?: any): any {
  const error_msg = error
    ? { name: error.name, message: error.message || String(error), stack: error.stack }
    : undefined;
  return error_msg;
}

function montaIdentificadorMsg(msg: any): string {
  const { message_id, id, whatsapp_id } = msg || {}

  let identificador: any = {};
  if (message_id) identificador.message_id = message_id;
  if (id) identificador.id = id;
  if (whatsapp_id) identificador.whatsapp_id = whatsapp_id;

  const identificadorString = JSON.stringify(identificador);
  return identificadorString;
}



function criaLogSessao(event: string, msg: any, chat_id: string, error?: any): void {
  try {
    //validacoes iniciais
    if (!chat_id || !event) {
      console.error('criaLogSessao - dados inválidos:', chat_id, msg, event);
      return;
    }
    //obter dados atuais
    const tagSessao = obterTagSessao(chat_id)
    const sessao = sessionStorage.getItem(tagSessao) || '[]';

    //adiciona novo
    const logsParseados = JSON.parse(sessao);
    const itemNovo = {
      identificador: montaIdentificadorMsg(msg),
      event,
      receivedAt: new Date().toISOString(),
      payload: msg,
      error: montaErroMsg(error)
    }
    logsParseados.push(itemNovo);

    // salva apenas 200 ultimos para evitar encher de log
    const logs = logsParseados.slice(-200);
    const logsStringuificado = JSON.stringify(logs);
    sessionStorage.setItem(tagSessao, logsStringuificado);
  }
  catch (e) {
    console.error('criaLogSessao - error:', e)
  }
}
